(function () {

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "../../";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea794"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea794"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8iBev", function(module, exports) {
$parcel$extendImportMap({
    "hVd95": "prism-javascript.003bb0d9.js",
    "5XAWp": "prism-bash.f6031ec6.js",
    "5vWgD": "prism-graphql.429e768b.js",
    "6ijNy": "prism-ini.25df9e30.js",
    "3dcDw": "prism-json.4baacd10.js",
    "38KM7": "prism-json5.cce49a67.js",
    "j6z8i": "prism-jsx.516b955d.js",
    "akuxC": "prism-makefile.0a666d44.js",
    "6bD26": "prism-markdown.4a7fc90a.js",
    "km5HQ": "prism-scss.cec3b303.js",
    "iFOQB": "prism-sql.7272de48.js",
    "knggI": "prism-tsx.c28b2d59.js",
    "foaYQ": "prism-typescript.c7432a42.js",
    "d5GAD": "prism-yaml.b0e96fe9.js",
    "6rIAR": "prism-line-numbers.73810f5d.js",
    "7tFEa": "prism-line-numbers.217ad99a.css",
    "2iHFc": "prism.fffec508.js",
    "7xNLC": "prism-one-light.55d150f8.css",
    "e8zl5": "marked.umd.95f20d30.js",
    "73tvQ": "purify.c946478d.js",
    "g7N4e": "styles.0cc22177.css"
});

});

parcelRegister("6NpK2", function(module, exports) {

$parcel$export(module.exports, "fetchPath", function () { return $4f2b4968098282f8$export$5e86c84f80da1e08; });
$parcel$export(module.exports, "default", function () { return $4f2b4968098282f8$export$2e2bcd8739ae039; });

var $1UkIB = parcelRequire("1UkIB");

var $9Ju4i = parcelRequire("9Ju4i");

var $3FKio = parcelRequire("3FKio");
const $4f2b4968098282f8$var$showLoader = ()=>{
    document.documentElement.classList.add('is-loading');
    (0, $3FKio.toast)({
        message: 'Loading',
        type: 'loader'
    });
};
const $4f2b4968098282f8$var$clearLoaderTimeout = (timeout, hasTimeout = true)=>{
    clearTimeout(timeout);
    if (hasTimeout) // NOTE: Add a deliberate delay to comprehend the spinner
    setTimeout((0, $3FKio.removeLoaderToast), 200);
    else (0, $3FKio.removeLoaderToast)();
};
const $4f2b4968098282f8$var$getContextObject = (path)=>{
    const str = path && path.split('/')[3];
    const obj = {};
    if (str) {
        const params = str.split(':').filter((i)=>i).join('&').split('&');
        for(let i = 0; i < params.length; i = i + 2)obj[params[i]] = params[i + 1];
    }
    return obj;
};
let $4f2b4968098282f8$var$controller;
let $4f2b4968098282f8$var$loaderTimeout;
const $4f2b4968098282f8$export$5e86c84f80da1e08 = async (state, isPushState)=>{
    const oldContext = $4f2b4968098282f8$var$getContextObject(state.from);
    const newContext = $4f2b4968098282f8$var$getContextObject(state.path);
    const csrfToken = document.head.querySelector('[name=csrf-token][content]').content;
    const setupLoader = ()=>$4f2b4968098282f8$var$loaderTimeout = setTimeout($4f2b4968098282f8$var$showLoader, (0, $9Ju4i.PAGE_LOADER_DELAY_MS));
    try {
        setupLoader();
        if ($4f2b4968098282f8$var$controller) $4f2b4968098282f8$var$controller.abort();
        $4f2b4968098282f8$var$controller = new AbortController();
        const response = await fetch(state.path, {
            method: 'get',
            headers: {
                Accept: 'roast/mixed',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': csrfToken
            },
            signal: $4f2b4968098282f8$var$controller.signal
        });
        const root = await (0, $1UkIB.handleResponse)(response, newContext, oldContext);
        if (state.path.includes('#')) window.location = state.path;
        $4f2b4968098282f8$var$clearLoaderTimeout($4f2b4968098282f8$var$loaderTimeout);
        if (root) {
            const newState = {
                path: state.path
            };
            if (isPushState && !response.headers.get('x-intra-redirect')) history.pushState(newState, '', state.path);
        }
    } catch (err) {
        if (err.name == 'AbortError') $4f2b4968098282f8$var$clearLoaderTimeout($4f2b4968098282f8$var$loaderTimeout, false);
        else console.error(err);
    }
};
const $4f2b4968098282f8$var$stateFetch = async ()=>{
    const path = window.location.pathname + window.location.search;
    history.replaceState({
        path: path,
        title: document.title
    }, '', path);
    window.addEventListener('popstate', (popStateEvent)=>{
        if (!popStateEvent.state) return;
        setTimeout(()=>{
            $4f2b4968098282f8$export$5e86c84f80da1e08(popStateEvent.state, false);
        }, 0);
        return true;
    });
};
var $4f2b4968098282f8$export$2e2bcd8739ae039 = $4f2b4968098282f8$var$stateFetch;

});
parcelRegister("1UkIB", function(module, exports) {

$parcel$export(module.exports, "handleResponse", function () { return $163b17a5639ec7db$export$c113a67a6762ad2e; });

var $jLxOW = parcelRequire("jLxOW");

var $6NpK2 = parcelRequire("6NpK2");

var $3FKio = parcelRequire("3FKio");

var $6Tjdo = parcelRequire("6Tjdo");

var $g76jX = parcelRequire("g76jX");

var $6E8fP = parcelRequire("6E8fP");

var $df7LC = parcelRequire("df7LC");

var $59PtE = parcelRequire("59PtE");

var $bEEr7 = parcelRequire("bEEr7");

var $5IAKC = parcelRequire("5IAKC");

var $f4qAx = parcelRequire("f4qAx");
parcelRequire("2Xp7J");
var $4Lpa2 = parcelRequire("4Lpa2");
const $163b17a5639ec7db$var$parseJson = (j = '{}')=>{
    try {
        if (typeof j !== 'object') return JSON.parse(j || '{}');
        else return j;
    } catch (error) {
        return {};
    }
};
const $163b17a5639ec7db$var$setFocus = (nextRoot)=>{
    let elementToFocus = nextRoot.querySelector('[autofocus], [data-kui-navigation-custom-focus]');
    const isInsideInertContainer = elementToFocus?.closest('[inert]');
    if (elementToFocus?.hasAttribute('data-kui-navigation-custom-focus')) elementToFocus.setAttribute('tabindex', '-1');
    if (!elementToFocus || isInsideInertContainer) {
        const h1s = nextRoot.querySelectorAll('main h1, [role="dialog"] h1');
        h1s.forEach((item)=>{
            item?.setAttribute('tabindex', '-1');
            elementToFocus = item;
        });
    }
    elementToFocus?.focus();
};
const $163b17a5639ec7db$var$persistShowHides = (newInput, oldInput)=>{
    const newRoot = newInput.closest('[data-toggle-display="root"]');
    const newTargets = newRoot.querySelectorAll('[data-toggle-display="target"]');
    const oldRoot = oldInput.closest('[data-toggle-display="root"]');
    const oldTargets = oldRoot.querySelectorAll('[data-toggle-display="target"]');
    [
        ...newTargets
    ].forEach((target, i)=>{
        target.hidden = oldTargets[i].hidden;
    });
};
const $163b17a5639ec7db$var$persistChecked = (oldInput, newInput)=>{
    const oldChecked = oldInput.checked;
    newInput.checked = oldChecked;
};
const $163b17a5639ec7db$var$persistValue = (oldInput, newInput)=>{
    const oldValue = oldInput.value;
    newInput.value = oldValue;
};
const $163b17a5639ec7db$var$persistInputs = (nextRoot)=>{
    [
        ...(0, $6E8fP.findAll)('[kui-input-persist]', nextRoot)
    ].forEach((newInput)=>{
        const isRadioCheckbox = [
            'radio',
            'checkbox'
        ].includes(newInput.type);
        const isConditionalField = newInput.hasAttribute('data-conditional-field');
        const oldInput = isRadioCheckbox ? (0, $df7LC.find)(`[name='${newInput.getAttribute('name')}'][value='${newInput.getAttribute('value')}']`) : isConditionalField ? (0, $df7LC.find)(`[name='${newInput.getAttribute('name')}']`) : (0, $df7LC.find)((0, $jLxOW.getElementSelector)(newInput, {
            root: nextRoot
        }));
        if (oldInput) {
            const updateFunction = isRadioCheckbox ? $163b17a5639ec7db$var$persistChecked : $163b17a5639ec7db$var$persistValue;
            updateFunction(oldInput, newInput);
            if (isRadioCheckbox && newInput.getAttribute('kui-on-change') && newInput.getAttribute('kui-on-change').startsWith('toggleDisplay.')) $163b17a5639ec7db$var$persistShowHides(newInput, oldInput);
        }
    });
};
const $163b17a5639ec7db$var$replaceDom = (prevRoot, nextRoot, isFromHome, isToHome, isChangeSub, isChangeContext, isModalContext)=>{
    if (isChangeSub && !isModalContext) nextRoot.classList.add('has-page-transition');
    $163b17a5639ec7db$var$persistInputs(nextRoot);
    (0, $f4qAx.persistState)(prevRoot, nextRoot);
    const oldPageTitleEl = prevRoot.querySelector('[data-page-title]');
    const oldPageTitle = oldPageTitleEl.getAttribute('data-page-title');
    prevRoot.replaceWith(nextRoot);
    const pageTitleEl = nextRoot.querySelector('[data-page-title]');
    if (pageTitleEl) document.title = pageTitleEl.getAttribute('data-page-title');
    if (// If a modal URL, we don't want to set focus on the H1
    !isModalContext && (document.title !== oldPageTitle || isChangeContext)) $163b17a5639ec7db$var$setFocus(nextRoot);
    (0, $6Tjdo.handleOnLoads)();
    return nextRoot;
};
const $163b17a5639ec7db$var$navigate = (res, oldContext, newContext)=>{
    const parser = new DOMParser();
    const dom = parser.parseFromString(res.html, 'text/html');
    // Default to roast root, use Kinde root for custom UI
    // as roast wouldn't make sense in that context
    // fall back to body so custom ui doesn't break if omitted
    let ROOT_SELECTOR = '[data-roast-root]';
    let prevRoot = document.querySelector(ROOT_SELECTOR);
    if (!prevRoot) {
        ROOT_SELECTOR = '[data-kinde-root]';
        prevRoot = document.querySelector(ROOT_SELECTOR);
    }
    if (!prevRoot) {
        ROOT_SELECTOR = 'body';
        prevRoot = document.body;
    }
    const nextRoot = (0, $df7LC.find)(ROOT_SELECTOR, dom);
    const metaCsrf = dom.querySelector('meta[name="csrf-token"]');
    const currentMetaCsrf = document.querySelector('meta[name="csrf-token"]');
    if (metaCsrf && currentMetaCsrf) currentMetaCsrf.content = metaCsrf.content;
    const isFromHome = (0, $59PtE.isHome)(oldContext);
    const isToHome = (0, $59PtE.isHome)(newContext);
    const isModalContext = newContext && 'is_modal' in newContext;
    (async ()=>{
        await (0, $g76jX.sleep)();
    })();
    if (nextRoot) $163b17a5639ec7db$var$replaceDom(prevRoot, nextRoot, isFromHome, isToHome, (0, $bEEr7.isNewSub)(oldContext, newContext), (0, $5IAKC.isNewContext)(oldContext, newContext), isModalContext);
    return nextRoot;
};
const $163b17a5639ec7db$var$handleRedirect = (res)=>window.location = res.location;
const $163b17a5639ec7db$var$handleRefresh = ()=>(0, $6NpK2.fetchPath)(history.state, false);
const $163b17a5639ec7db$var$handleNoop = ()=>false;
const $163b17a5639ec7db$var$handlePolling = ()=>false;
const $163b17a5639ec7db$var$handleToast = (res)=>(0, $3FKio.toast)(res);
const $163b17a5639ec7db$var$handleMake = (res)=>(0, $4Lpa2.makeHandler)(res);
const $163b17a5639ec7db$var$handleAction = (action)=>{
    const actionMap = {
        show_toast: $163b17a5639ec7db$var$handleToast,
        noop: $163b17a5639ec7db$var$handleNoop,
        polling: $163b17a5639ec7db$var$handlePolling,
        redirect: $163b17a5639ec7db$var$handleRedirect,
        refresh_content: $163b17a5639ec7db$var$handleRefresh,
        make: $163b17a5639ec7db$var$handleMake
    };
    return actionMap[action] ? actionMap[action] : actionMap.noop;
};
const $163b17a5639ec7db$var$handleMixed = async (response, oldContext, newContext)=>{
    try {
        const res = await response.json();
        const json = $163b17a5639ec7db$var$parseJson(res.json);
        const html = $163b17a5639ec7db$var$parseJson(res.html);
        if (json && (json.action || json.actions)) {
            const actions = json.actions || [
                json
            ];
            actions.forEach((item)=>$163b17a5639ec7db$var$handleAction(item.action)(item));
        }
        if (json && json.action === 'noop') return 'noop';
        if (res.html && !html.actions) return $163b17a5639ec7db$var$navigate(res, oldContext, newContext);
        if (json?.actions?.[0]?.action === 'polling') return {
            action: 'polling',
            ...json.actions[0]
        };
    } catch (err) {
        console.error(err);
    }
};
const $163b17a5639ec7db$var$handleUnknownResponseType = (response)=>{
    console.error(`Unknown response content-type. Received: ${response.headers.get('content-type')}. Expected: roast/mixed`);
};
const $163b17a5639ec7db$var$handleFileToLarge = ()=>{
    throw 'Your uploaded file is too large, check the accepted size';
};
const $163b17a5639ec7db$var$getHandleCode = (code)=>{
    const map = {
        413: $163b17a5639ec7db$var$handleFileToLarge,
        default: $163b17a5639ec7db$var$handleUnknownResponseType
    };
    return map[code] ? map[code] : map.default;
};
const $163b17a5639ec7db$var$handleTextHTML = (response)=>{
    const handleCode = $163b17a5639ec7db$var$getHandleCode(response.status);
    handleCode(response);
};
const $163b17a5639ec7db$var$handleContentType = (contentType)=>{
    const map = {
        'text/html': $163b17a5639ec7db$var$handleTextHTML,
        'roast/mixed': $163b17a5639ec7db$var$handleMixed,
        default: $163b17a5639ec7db$var$handleUnknownResponseType
    };
    return map[contentType] ? map[contentType] : map.default;
};
const $163b17a5639ec7db$export$c113a67a6762ad2e = async (response, newContext, oldContext)=>{
    const internalRedirectTo = response.headers.get('x-intra-redirect');
    const contentType = response.headers.get('content-type');
    if (internalRedirectTo && !history.state.path.endsWith(internalRedirectTo)) // Make back button skip pages it was redirected from (e.g. modal)
    history.pushState({
        path: internalRedirectTo
    }, '', internalRedirectTo);
    const func = $163b17a5639ec7db$var$handleContentType(contentType);
    return await func(response, oldContext, newContext);
};

});
parcelRegister("jLxOW", function(module, exports) {

$parcel$export(module.exports, "getElementSelector", function () { return $e63ca4335db4d017$export$b609704f371f3e39; });
const $e63ca4335db4d017$var$getAncestorElements = (element, parameters)=>{
    const ancestors = [];
    while(element){
        if (parameters?.root && element == parameters?.root) break;
        const tagName = element.nodeName.toLowerCase();
        const id = element.id ? `#${element.id}` : '';
        let className = '';
        if (element.className && typeof element.className === 'string') // escape class names
        className = `.${element.className.trim().replace(/\s+/g, '.').replace(/[:*+?^${}()|[\]\\]/gi, '\\$&')}`;
        ancestors.unshift({
            element: element,
            selector: tagName + id + className
        });
        element = element.parentNode !== document ? element.parentNode : false;
    }
    return ancestors;
};
const $e63ca4335db4d017$var$getNthIndex = (element, sameType = true)=>{
    let c = element;
    let nth = 1;
    while(c.previousElementSibling !== null){
        if (!sameType || c.previousElementSibling.nodeName === element.nodeName) nth++;
        c = c.previousElementSibling;
    }
    return nth;
};
const $e63ca4335db4d017$var$isNthSelectorNeeded = (selector, path)=>{
    const querySelector = path === '' ? selector : `${path} > ${selector}`;
    return document.querySelectorAll(querySelector).length > 1;
};
const $e63ca4335db4d017$var$buildSelectorString = (parents)=>{
    const selectorArr = [];
    parents.forEach((parent)=>{
        if ($e63ca4335db4d017$var$isNthSelectorNeeded(parent.selector, selectorArr.join(' > '))) parent.selector += `:nth-of-type(${$e63ca4335db4d017$var$getNthIndex(parent.element)})`;
        selectorArr.push(parent.selector);
    });
    return selectorArr.join(' > ');
};
const $e63ca4335db4d017$export$b609704f371f3e39 = (element, parameters)=>{
    if (!(element instanceof HTMLElement)) throw new Error('element must be of type `HTMLElement`.');
    return $e63ca4335db4d017$var$buildSelectorString($e63ca4335db4d017$var$getAncestorElements(element, parameters));
};

});

parcelRegister("3FKio", function(module, exports) {

$parcel$export(module.exports, "removeLoaderToast", function () { return $2ac91cc51551f27c$export$72601a8e7a675d38; });
$parcel$export(module.exports, "toast", function () { return $2ac91cc51551f27c$export$b410431fab84fa58; });
/* Draws heavy influence from https://web.dev/building-a-toast-component/ */ const $2ac91cc51551f27c$var$Toaster = document.querySelector('[data-kui-toaster]');
const $2ac91cc51551f27c$var$cloneToastTemplate = (msg, type)=>{
    const template = document.querySelector('[data-kui-toast-template]');
    const clone = template.content.cloneNode(true);
    const containerEl = clone.querySelector(':first-child');
    const msgEl = clone.querySelector('[data-kui-toast-msg]');
    containerEl.classList.add(`kui-toast--${type}`);
    containerEl.setAttribute(`data-kui-toast-${type}`, 'true');
    msgEl.textContent = msg;
    return clone;
};
const $2ac91cc51551f27c$var$addToQueue = (toast)=>{
    const first = $2ac91cc51551f27c$var$Toaster.offsetHeight;
    $2ac91cc51551f27c$var$Toaster.appendChild(toast);
    const last = $2ac91cc51551f27c$var$Toaster.offsetHeight;
    const invert = last - first;
    $2ac91cc51551f27c$var$Toaster.animate([
        {
            transform: `translateY(${invert}px)`
        },
        {
            transform: 'translateY(0)'
        }
    ], {
        duration: 150,
        easing: 'ease-out'
    });
};
const $2ac91cc51551f27c$var$addToast = (toast)=>{
    const { matches: motionOK } = window.matchMedia('(prefers-reduced-motion: no-preference)');
    $2ac91cc51551f27c$var$Toaster.children.length && motionOK ? $2ac91cc51551f27c$var$addToQueue(toast) : $2ac91cc51551f27c$var$Toaster.appendChild(toast);
};
const $2ac91cc51551f27c$export$72601a8e7a675d38 = ()=>{
    if (!$2ac91cc51551f27c$var$Toaster) return;
    const toastEl = $2ac91cc51551f27c$var$Toaster.querySelector('[data-kui-toast-loader]:first-child');
    if (toastEl) $2ac91cc51551f27c$var$Toaster.removeChild(toastEl);
    document.documentElement.classList.remove('is-loading');
};
const $2ac91cc51551f27c$var$showToast = (res)=>{
    const { message: message, type: type = 'success', is_visually_hidden: is_visually_hidden = false } = res;
    const clone = $2ac91cc51551f27c$var$cloneToastTemplate(message, type);
    const isLoader = type === 'loader';
    if (isLoader) $2ac91cc51551f27c$var$Toaster.appendChild(clone);
    else {
        $2ac91cc51551f27c$var$addToast(clone);
        const toastEl = $2ac91cc51551f27c$var$Toaster.querySelector('[data-kui-toast]:last-child');
        if (is_visually_hidden) toastEl.classList.add('kui-util-hide-visually');
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve)=>{
            await Promise.allSettled(toastEl.getAnimations().map((animation)=>animation.finished));
            $2ac91cc51551f27c$var$Toaster.removeChild(toastEl);
            resolve();
        });
    }
};
const $2ac91cc51551f27c$export$b410431fab84fa58 = (res = {})=>{
    if (!$2ac91cc51551f27c$var$Toaster) return;
    $2ac91cc51551f27c$var$showToast(res);
};

});

parcelRegister("6Tjdo", function(module, exports) {

$parcel$export(module.exports, "handleOnLoads", function () { return $5046c8dac1266703$export$c015d9a87e159176; });
$parcel$export(module.exports, "bind", function () { return $5046c8dac1266703$export$2385a24977818dd0; });

var $laGbt = parcelRequire("laGbt");

var $92Eyg = parcelRequire("92Eyg");

var $6NpK2 = parcelRequire("6NpK2");

var $eDRCA = parcelRequire("eDRCA");

var $4C6DL = parcelRequire("4C6DL");
const $5046c8dac1266703$var$handledNativeEvents = [
    'click',
    'change',
    'mouseup',
    'input',
    'keyup',
    'keydown',
    'submit',
    'focusin',
    'blur'
];
const $5046c8dac1266703$var$fire = (el, handler, e)=>{
    const attribute = el.getAttribute(handler);
    const eventHandlers = attribute.trim().split(' ');
    eventHandlers.forEach((method)=>{
        const parts = method.split('.');
        (0, $laGbt.eventMap)[parts[0]][parts[1]](el, e);
    });
};
const $5046c8dac1266703$var$fireClosestHandler = (e)=>{
    const handler = `kui-on-${e.type}`;
    const el = e.target.closest(`[${handler}]`);
    if (el) $5046c8dac1266703$var$fire(el, handler, e);
};
const $5046c8dac1266703$export$c015d9a87e159176 = ()=>{
    const handler = 'kui-on-load';
    const loadEls = document.querySelectorAll(`[${handler}]`);
    (0, $92Eyg.each)(loadEls, (el)=>$5046c8dac1266703$var$fire(el, handler));
};
const $5046c8dac1266703$var$handleNativeEvents = ()=>{
    $5046c8dac1266703$var$handledNativeEvents.forEach((type)=>{
        document.body.addEventListener(type, $5046c8dac1266703$var$fireClosestHandler, true);
    });
};
const $5046c8dac1266703$var$navigate = (e)=>{
    const el = e.target.closest('a');
    if (el && el.hostname === window.location.hostname && !el.hasAttribute('download') && !el.hasAttribute('data-force-page-reload-via-link') && !el.hasAttribute('data-in-page-link')) {
        e.preventDefault();
        if ((0, $4C6DL.hasUnsavedChanges)()) {
            if (!confirm(`Are you sure you want to leave this page? Your changes won't be saved.`)) //  User asked to stay, do not redirect
            return;
            else (0, $4C6DL.resetUnsavedChanges)();
        }
        const path = el.pathname + el.search;
        (0, $6NpK2.fetchPath)({
            path: path,
            from: window.location.pathname
        }, true);
    }
};
const $5046c8dac1266703$var$handleInternalLinks = ()=>{
    document.body.addEventListener('click', $5046c8dac1266703$var$navigate);
};
const $5046c8dac1266703$var$handleFormSubmit = ()=>{
    document.body.addEventListener('submit', (0, $eDRCA.formSubmit));
};
const $5046c8dac1266703$export$2385a24977818dd0 = ()=>{
    $5046c8dac1266703$var$handleInternalLinks();
    $5046c8dac1266703$var$handleFormSubmit();
    $5046c8dac1266703$var$handleNativeEvents();
    $5046c8dac1266703$export$c015d9a87e159176();
};

});
parcelRegister("laGbt", function(module, exports) {

$parcel$export(module.exports, "eventMap", function () { return $f69b410a2ca6c65b$export$ad0af8749a496627; });
$parcel$export(module.exports, "register", function () { return $f69b410a2ca6c65b$export$6503ec6e8aabbaf; });
const $f69b410a2ca6c65b$export$ad0af8749a496627 = {};
function $f69b410a2ca6c65b$export$6503ec6e8aabbaf(controller, methods) {
    $f69b410a2ca6c65b$export$ad0af8749a496627[controller] = methods;
}

});

parcelRegister("92Eyg", function(module, exports) {

$parcel$export(module.exports, "each", function () { return $6953c1a77320f4ee$export$79b2f7037acddd43; });
const $6953c1a77320f4ee$export$79b2f7037acddd43 = (array, func, inc = 1)=>{
    for(let i = 0; i < array.length; i += inc)func(array[i], i);
};

});

parcelRegister("eDRCA", function(module, exports) {

$parcel$export(module.exports, "formSubmit", function () { return $aa8e4d458133815d$export$e382ca0e4dd19c27; });
$parcel$export(module.exports, "resetFormLoading", function () { return $aa8e4d458133815d$export$c387045d3184c515; });

var $1UkIB = parcelRequire("1UkIB");

var $4C6DL = parcelRequire("4C6DL");

var $3296d = parcelRequire("3296d");

var $gT1UC = parcelRequire("gT1UC");
let $aa8e4d458133815d$var$isFormSubmitting = false;
const $aa8e4d458133815d$export$e382ca0e4dd19c27 = async (e)=>{
    const form = e.target;
    // Ignore forms that purely close dialogs via `method="dialog"`
    if (form.method === 'dialog') return;
    const isFileUpload = form.getAttribute('data-is-file-upload');
    const isEndUserForm = form.getAttribute('data-kinde-form'); // NOTE: This will be used everywhere eventually
    const isMakeForm = form?.closest('[data-kui-chat-prompt]');
    if (form) e.preventDefault();
    (0, $4C6DL.resetUnsavedChanges)();
    /* Prevent multiple submissions */ if ($aa8e4d458133815d$var$isFormSubmitting) return false;
    $aa8e4d458133815d$var$isFormSubmitting = true;
    // Factor in forms submitted by remote buttons
    const submitButton = isFileUpload ? form.querySelector('[data-kui-file-upload-trigger]') : e.submitter || form.querySelector('button[type="submit"]');
    const liveRegion = submitButton.nextElementSibling;
    const submitButtonText = (0, $gT1UC.getLoadingButtonText)(submitButton);
    if (isEndUserForm) (0, $gT1UC.loadingButton)(submitButton);
    else {
        form.classList.add('is-loading');
        submitButton.classList.add('is-loading');
        if (liveRegion) liveRegion.textContent = isFileUpload ? 'File is uploading' : isMakeForm ? 'Response from Kinde in progress. Press ENTER to stop the response.' : 'Form submitting';
    }
    const formData = new FormData(form);
    const searchParams = new URLSearchParams();
    for (const [key, value] of searchParams.entries())formData.append(key, value);
    if (submitButton.getAttribute('name')) formData.append(submitButton.getAttribute('name'), submitButton.getAttribute('value'));
    const path = form.action;
    const csrfToken = document.head.querySelector('[name=csrf-token][content]').content;
    let responseType;
    try {
        const response = await fetch(path, {
            method: form.method,
            body: formData,
            redirect: 'error',
            headers: {
                Accept: 'roast/mixed',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': csrfToken,
                'X-Client-Time': Date.now()
            }
        });
        responseType = await (0, $1UkIB.handleResponse)(response);
    } catch (error) {
        if (isEndUserForm) (0, $gT1UC.restoreLoadingButton)(submitButton, submitButtonText);
        else {
            $aa8e4d458133815d$export$c387045d3184c515(submitButton);
            (0, $3296d.showFormFieldError)(form, error);
        }
    } finally{
        // Means forms can't be resubmitted whilst redirect takes place
        if (responseType !== 'redirect') $aa8e4d458133815d$var$isFormSubmitting = false;
    }
};
const $aa8e4d458133815d$export$c387045d3184c515 = (submitButton)=>{
    const liveRegion = submitButton.nextElementSibling;
    submitButton.form.classList.remove('is-loading');
    submitButton.classList.remove('is-loading');
    liveRegion.textContent = '';
};

});
parcelRegister("4C6DL", function(module, exports) {

$parcel$export(module.exports, "hasUnsavedChanges", function () { return $35bfdcafbb23618e$export$cb4fe9993410f0a9; });
$parcel$export(module.exports, "resetUnsavedChanges", function () { return $35bfdcafbb23618e$export$3299f181c601479d; });
$parcel$export(module.exports, "unsavedChanges", function () { return $35bfdcafbb23618e$export$ba693124bd9dae7; });

var $laGbt = parcelRequire("laGbt");
let $35bfdcafbb23618e$var$isDirty = false;
const $35bfdcafbb23618e$export$cb4fe9993410f0a9 = ()=>$35bfdcafbb23618e$var$isDirty;
const $35bfdcafbb23618e$var$handleUnload = (e)=>{
    e.preventDefault();
    return e.returnValue = '';
};
const $35bfdcafbb23618e$export$3299f181c601479d = ()=>{
    $35bfdcafbb23618e$var$isDirty = false;
    window.removeEventListener('beforeunload', $35bfdcafbb23618e$var$handleUnload);
};
function $35bfdcafbb23618e$var$handleChange() {
    $35bfdcafbb23618e$var$isDirty = true;
    window.addEventListener('beforeunload', $35bfdcafbb23618e$var$handleUnload);
}
const $35bfdcafbb23618e$var$setFormListeners = (form)=>{
    const fields = form.querySelectorAll('input:not([type="search"]), select, textarea');
    [
        ...fields
    ].forEach((field)=>{
        // eslint-disable-next-line no-constant-condition
        const eventType = field.nodeName = 'change';
        field.addEventListener(eventType, $35bfdcafbb23618e$var$handleChange);
    });
};
const $35bfdcafbb23618e$var$init = (form)=>{
    $35bfdcafbb23618e$var$setFormListeners(form);
};
const $35bfdcafbb23618e$export$ba693124bd9dae7 = ()=>{
    (0, $laGbt.register)('unsavedChanges', {
        init: $35bfdcafbb23618e$var$init
    });
};

});

parcelRegister("3296d", function(module, exports) {

$parcel$export(module.exports, "showFormFieldError", function () { return $23589dedb6cf5e2f$export$2d721e062bd3690; });
const $23589dedb6cf5e2f$var$KUI_FORM_VALIDATION_MSG_CLIENT = 'kui-form-validation-msg-client';
const $23589dedb6cf5e2f$var$KUI_FORM_VALIDATION_MSG_SERVER = 'kui-form-validation-msg-server';
const $23589dedb6cf5e2f$var$KUI_FORM_VALIDATION_INPUT = 'kui-form-validation-input';
const $23589dedb6cf5e2f$export$2d721e062bd3690 = (form, error)=>{
    if (!form && !error) return;
    const input = form.querySelector(`[${$23589dedb6cf5e2f$var$KUI_FORM_VALIDATION_INPUT}]`);
    const errorMsgClient = form.querySelector(`[${$23589dedb6cf5e2f$var$KUI_FORM_VALIDATION_MSG_CLIENT}]`);
    const errorMsgServer = form.querySelector(`[${$23589dedb6cf5e2f$var$KUI_FORM_VALIDATION_MSG_SERVER}]`);
    // Remove server-side errors from DOM
    if (errorMsgServer) errorMsgServer.style.display = 'none';
    if (errorMsgClient) {
        errorMsgClient.id = $23589dedb6cf5e2f$var$KUI_FORM_VALIDATION_MSG_CLIENT;
        errorMsgClient.classList.add('kui-form-field-error-msg', 'kui-form-field-error-msg--variant-block', 'kui-util-type-body-2');
        errorMsgClient.textContent = error;
    }
    if (input) {
        input.setAttribute('aria-describedby', $23589dedb6cf5e2f$var$KUI_FORM_VALIDATION_MSG_CLIENT);
        input.setAttribute('aria-invalid', 'true');
    }
};

});

parcelRegister("gT1UC", function(module, exports) {

$parcel$export(module.exports, "loadingButton", function () { return $c4b3441c0825aa9b$export$e737248121a0521e; });
$parcel$export(module.exports, "getLoadingButtonText", function () { return $c4b3441c0825aa9b$export$91fa9d984f13195b; });
$parcel$export(module.exports, "restoreLoadingButton", function () { return $c4b3441c0825aa9b$export$2fb0d2e5caf27b0c; });

var $cbpXQ = parcelRequire("cbpXQ");
const $c4b3441c0825aa9b$export$e737248121a0521e = (el)=>{
    if (!el) return;
    const spinnerTemplate = el.nextElementSibling;
    const spinnerContent = spinnerTemplate.content.cloneNode(true);
    el.classList.add('kinde-is-loading');
    el.textContent = '';
    el.appendChild(spinnerContent);
    el.setAttribute('aria-disabled', 'true');
    (0, $cbpXQ.generateLiveRegion)('formSubmit');
};
const $c4b3441c0825aa9b$export$91fa9d984f13195b = (el)=>{
    const buttonTextEl = el.querySelector('[data-kinde-button-text]');
    if (!buttonTextEl) return;
    return buttonTextEl.textContent;
};
const $c4b3441c0825aa9b$export$2fb0d2e5caf27b0c = (el, originalText)=>{
    if (!el) return;
    const spinnerEl = el.querySelector('[data-kinde-form-submit-spinner]');
    if (spinnerEl) spinnerEl.remove();
    const buttonTextEl = document.createElement('span');
    buttonTextEl.className = 'kinde-button-text';
    buttonTextEl.setAttribute('data-kinde-button-text', 'true');
    buttonTextEl.textContent = originalText;
    el.classList.remove('kinde-is-loading');
    el.removeAttribute('aria-disabled');
    el.appendChild(buttonTextEl);
    (0, $cbpXQ.clearLiveRegion)();
};

});
parcelRegister("cbpXQ", function(module, exports) {

$parcel$export(module.exports, "clearLiveRegion", function () { return $8deaa70dc2d110da$export$6d886893bb3bfb69; });
$parcel$export(module.exports, "getLiveRegion", function () { return $8deaa70dc2d110da$export$1870415c73c2ac8e; });
$parcel$export(module.exports, "generateLiveRegion", function () { return $8deaa70dc2d110da$export$27a9c3442f02de69; });

var $2Sg5u = parcelRequire("2Sg5u");
const $8deaa70dc2d110da$var$LiveRegion = document.querySelector('[data-kinde-live-region]');
const $8deaa70dc2d110da$var$LiveRegionNames = {
    copyToClipboard: 'CopyToClipboard',
    copyToClipboardAlt: 'CopyToClipboardAlt',
    formLoading: 'FormLoading',
    formSubmit: 'FormSubmit'
};
const $8deaa70dc2d110da$export$6d886893bb3bfb69 = ()=>$8deaa70dc2d110da$var$LiveRegion.textContent = null;
const $8deaa70dc2d110da$export$1870415c73c2ac8e = (name)=>{
    if (!$8deaa70dc2d110da$var$LiveRegion) return;
    const dataAttrPrefix = 'kindeLiveRegion';
    const dataAttrName = `${dataAttrPrefix}${$8deaa70dc2d110da$var$LiveRegionNames[name]}`;
    if (!dataAttrName) {
        console.warn(`Kinde: No live region data attribute matching: \u{201C}${dataAttrName}\u{201D}`);
        return;
    }
    return $8deaa70dc2d110da$var$LiveRegion.dataset[dataAttrName];
};
const $8deaa70dc2d110da$export$27a9c3442f02de69 = (name, hasTimeout = false)=>{
    const liveRegion = $8deaa70dc2d110da$export$1870415c73c2ac8e(name);
    $8deaa70dc2d110da$var$LiveRegion.textContent = liveRegion;
    if (hasTimeout) setTimeout(()=>{
        $8deaa70dc2d110da$var$LiveRegion.textContent = null;
    }, (0, $2Sg5u.LIVE_REGION_TIMEOUT_MS));
};

});
parcelRegister("2Sg5u", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_CLASS", function () { return $217d1a9435716b97$export$fb3d0eebfe85522a; });
$parcel$export(module.exports, "LIVE_REGION_TIMEOUT_MS", function () { return $217d1a9435716b97$export$eaa4066d935d3d0a; });
const $217d1a9435716b97$export$fb3d0eebfe85522a = 'is-kinde-active';
const $217d1a9435716b97$export$eaa4066d935d3d0a = 2000;

});





parcelRegister("g76jX", function(module, exports) {

$parcel$export(module.exports, "sleep", function () { return $bbb233f9007230ff$export$e772c8ff12451969; });
const $bbb233f9007230ff$export$e772c8ff12451969 = (m = 150)=>new Promise((r)=>setTimeout(r, m));

});

parcelRegister("6E8fP", function(module, exports) {

$parcel$export(module.exports, "findAll", function () { return $4d6ce1a80e4d860e$export$18200ea6c8035394; });
const $4d6ce1a80e4d860e$export$18200ea6c8035394 = (selector, el = document)=>el.querySelectorAll(selector);

});

parcelRegister("df7LC", function(module, exports) {

$parcel$export(module.exports, "find", function () { return $9a42b379aed88c7a$export$71aa6c912b956294; });
const $9a42b379aed88c7a$export$71aa6c912b956294 = (selector, el = document)=>el.querySelector(selector);

});

parcelRegister("59PtE", function(module, exports) {

$parcel$export(module.exports, "isHome", function () { return $3c15b956225127ce$export$947c0ccec8fe9e2a; });
const $3c15b956225127ce$export$947c0ccec8fe9e2a = (ctx)=>!ctx?.m || ctx?.m === 'home';

});

parcelRegister("bEEr7", function(module, exports) {

$parcel$export(module.exports, "isNewSub", function () { return $87c2cbf916868dbe$export$bcb4e29413feab9b; });
const $87c2cbf916868dbe$export$bcb4e29413feab9b = (oldCtx, newCtx)=>oldCtx?.s !== newCtx?.s;

});

parcelRegister("5IAKC", function(module, exports) {

$parcel$export(module.exports, "isNewContext", function () { return $429d91cc9f64b6a5$export$efd4e5a046bbe3a; });
const $429d91cc9f64b6a5$export$efd4e5a046bbe3a = (oldCtx, newCtx)=>oldCtx !== newCtx;

});

parcelRegister("f4qAx", function(module, exports) {

$parcel$export(module.exports, "persistState", function () { return $af8bda9a37f2fe19$export$9f127573fd964184; });
$parcel$export(module.exports, "treeView", function () { return $af8bda9a37f2fe19$export$7df5a6d0db541ce7; });

var $laGbt = parcelRequire("laGbt");
const $af8bda9a37f2fe19$var$persistBranchStates = (prevTree, nextTree)=>{
    const openTitles = [];
    prevTree.querySelectorAll('details[open] > summary').forEach((summary)=>{
        openTitles.push(summary.getAttribute('title'));
    });
    nextTree.querySelectorAll('details > summary').forEach((summary)=>{
        summary.parentElement.open = openTitles.includes(summary.getAttribute('title'));
    });
};
const $af8bda9a37f2fe19$export$9f127573fd964184 = (prevRoot, nextRoot)=>{
    const prevTrees = prevRoot.querySelectorAll('[data-kui-tree-view-state-persisted][id]');
    const nextTrees = nextRoot.querySelectorAll('[data-kui-tree-view-state-persisted][id]');
    if (!prevTrees || !nextTrees) return;
    prevTrees.forEach((prevTree)=>{
        const id = prevTree.id;
        if (!id) return;
        const nextTree = nextRoot.querySelector(`[data-kui-tree-view-state-persisted][id="${id}"]`);
        if (!nextTree) return;
        // Check if there's an active search
        const prevSearchInputEl = prevTree.querySelector('input[type="search"]');
        const nextSearchInputEl = nextTree.querySelector('input[type="search"]');
        if (prevSearchInputEl?.value) {
            // If there's an active search, apply it to the new tree AND
            // maintain branch states
            nextSearchInputEl.value = prevSearchInputEl.value;
            // First collect and restore branch states BEFORE applying search
            $af8bda9a37f2fe19$var$persistBranchStates(prevTree, nextTree);
            // Then apply search which will expand matching branches
            $af8bda9a37f2fe19$var$search(nextSearchInputEl);
        } else // No search active, restore normal open/closed states
        $af8bda9a37f2fe19$var$persistBranchStates(prevTree, nextTree);
    });
};
const $af8bda9a37f2fe19$var$resetTree = (itemsEl)=>{
    itemsEl.forEach((item)=>{
        item.hidden = false;
        const branchNode = item.querySelector('details');
        if (branchNode) branchNode.open = false;
    });
};
const $af8bda9a37f2fe19$var$search = (el)=>{
    const rootEl = el.closest('[data-kui-tree-view]');
    if (!rootEl) return;
    const itemsListEl = rootEl.querySelector('[data-kui-tree-view-items]');
    if (!itemsListEl) return;
    const itemsEl = itemsListEl.querySelectorAll('li');
    if (!itemsEl.length) return;
    const noResultsEl = rootEl.querySelector('[data-kui-tree-view-search-no-results]');
    const searchTermMarkEl = noResultsEl?.querySelector('mark');
    const liveRegionEl = rootEl.querySelector('[aria-live]');
    // Early return if required elements missing
    if (!noResultsEl || !searchTermMarkEl || !liveRegionEl) return;
    // Handle empty search - reset tree view/no results/live region
    if (!el?.value) {
        $af8bda9a37f2fe19$var$resetTree(itemsEl);
        noResultsEl.hidden = true;
        liveRegionEl.textContent = '';
        return;
    }
    const searchTerm = el.value.toLowerCase();
    let matchCount = 0;
    const matchedBranchDescendants = new Set();
    // Update search term in no results message
    searchTermMarkEl.textContent = `${el.value}`;
    itemsEl.forEach((item)=>{
        const itemText = item.querySelector('summary, a, button')?.textContent.trim().toLowerCase();
        const isMatch = itemText?.includes(searchTerm);
        const branchNode = item.querySelector('details');
        const isNested = !!item.parentElement.closest('li');
        if (isMatch) {
            matchCount++;
            item.hidden = false;
            // For nested items (branch or leaf), show parent hierarchy first
            if (isNested) {
                let parent = item.parentElement.closest('li');
                while(parent){
                    parent.hidden = false;
                    const parentBranch = parent.querySelector('details');
                    if (parentBranch) parentBranch.open = true;
                    parent = parent.parentElement.closest('li');
                }
            }
            // If matching item is a branch, show its descendants
            if (branchNode) {
                branchNode.open = true;
                item.querySelectorAll('li').forEach((descendant)=>{
                    descendant.hidden = false;
                    matchedBranchDescendants.add(descendant);
                });
            }
        } else if (!matchedBranchDescendants.has(item)) item.hidden = searchTerm;
    });
    // Toggle no results message
    if (noResultsEl) noResultsEl.hidden = matchCount > 0 || !searchTerm;
    // Update ARIA live region
    if (liveRegionEl && searchTerm) liveRegionEl.textContent = `Found ${matchCount} ${matchCount === 1 ? 'item' : 'items'} matching \u{201C}${searchTerm}\u{201D}`;
    else if (liveRegionEl) liveRegionEl.textContent = '';
};
const $af8bda9a37f2fe19$export$7df5a6d0db541ce7 = ()=>{
    (0, $laGbt.register)('treeView', {
        search: $af8bda9a37f2fe19$var$search
    });
};

});

parcelRegister("2Xp7J", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $227494845d5ff455$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "makeHandler", function () { return (parcelRequire("4Lpa2")).makeHandler; });

var $laGbt = parcelRequire("laGbt");

var $4Lpa2 = parcelRequire("4Lpa2");

var $hOfxh = parcelRequire("hOfxh");
parcelRequire("65UhT");
const $227494845d5ff455$export$dd44f18ab656f3bb = ()=>{
    (0, $laGbt.register)('make', {
        start: (0, $4Lpa2.makeHandler)
    });
    (0, $laGbt.register)('makeInteractiveEvents', {
        initializeSSE: $4Lpa2.initializeSSE
    });
    (0, $laGbt.register)('treeViewItem', {
        handleTreeViewItemClick: $hOfxh.handleTreeViewItemClick,
        loadInitialFileContent: $hOfxh.loadInitialFileContent
    });
};

});
parcelRegister("4Lpa2", function(module, exports) {

$parcel$export(module.exports, "makeHandler", function () { return $377f11a9d239d799$export$2ee853984d147030; });
$parcel$export(module.exports, "initializeSSE", function () { return $377f11a9d239d799$export$ad591f68158446c9; });

var $gbP80 = parcelRequire("gbP80");

var $hZoxd = parcelRequire("hZoxd");

var $fnzEC = parcelRequire("fnzEC");

var $eDRCA = parcelRequire("eDRCA");

var $k6XfV = parcelRequire("k6XfV");

var $65UhT = parcelRequire("65UhT");
const $377f11a9d239d799$var$togglePromptButtons = (submitButtonEl, containerEl, isShowStop = false)=>{
    const stopButtonEl = containerEl.querySelector('[data-kui-chat-prompt-stop-button]');
    if (!stopButtonEl) return {
        submitButtonEl: submitButtonEl,
        stopButtonEl: null
    };
    submitButtonEl.style.display = isShowStop ? 'none' : 'inline-flex';
    stopButtonEl.style.display = isShowStop ? 'inline-flex' : 'none';
    return {
        submitButtonEl: submitButtonEl,
        stopButtonEl: stopButtonEl
    };
};
const $377f11a9d239d799$var$setupStopButton = (submitButtonEl, containerEl)=>{
    const { stopButtonEl: stopButtonEl } = $377f11a9d239d799$var$togglePromptButtons(submitButtonEl, containerEl, true);
    stopButtonEl.onclick = ()=>{
        (0, $hZoxd.longPoll).cancel();
        $377f11a9d239d799$export$2ee853984d147030({
            event: 'end',
            message: 'Stopped by user'
        });
    };
};
const $377f11a9d239d799$export$2ee853984d147030 = async (res)=>{
    const { event: event } = res;
    const chatLogContainerEl = document.querySelector('[data-kui-chat-log]');
    const promptContainerEl = document.querySelector('[data-kui-chat-prompt]');
    if (!chatLogContainerEl || !promptContainerEl) {
        console.warn('Required chat container elements not found');
        return;
    }
    const formSubmitBtnEl = promptContainerEl.querySelector('button[type="submit"]');
    const promptInputEl = promptContainerEl.querySelector('textarea');
    if (!promptInputEl || !formSubmitBtnEl) {
        console.warn('Required chat prompt elements not found');
        return;
    }
    switch(event){
        case 'start':
            {
                const { job_id: job_id, project_id: project_id, prompt: prompt } = res;
                // Clear the input field
                promptInputEl.value = '';
                // Render user prompt first
                await (0, $gbP80.renderUserPrompt)(prompt, chatLogContainerEl);
                // Setup stop button
                $377f11a9d239d799$var$setupStopButton(formSubmitBtnEl, promptContainerEl);
                // Append form data
                const formData = new FormData();
                formData.append('p_job_id', job_id);
                formData.append('project_id', project_id);
                // Start polling - can be cancelled by stop button
                (0, $hZoxd.longPoll)('/make/progress', formData, (0, $gbP80.renderMakeResponse)(job_id, chatLogContainerEl));
                break;
            }
        case 'failure':
        case 'end':
            {
                // Finalise any active streaming renderers
                const activeRenderers = chatLogContainerEl.querySelectorAll(`[id^="${(0, $fnzEC.RESPONSE_ID_PREFIX)}"]`);
                activeRenderers.forEach((responseEl)=>{
                    if (responseEl._streamingRenderer) responseEl._streamingRenderer.finalize();
                });
                formSubmitBtnEl.disabled = true;
                promptInputEl.value = '';
                promptInputEl.focus();
                (0, $eDRCA.resetFormLoading)(formSubmitBtnEl);
                $377f11a9d239d799$var$togglePromptButtons(formSubmitBtnEl, promptContainerEl, false);
                (0, $k6XfV.scrollToBottom)(chatLogContainerEl);
                break;
            }
        default:
            break;
    }
};
const $377f11a9d239d799$export$75779d46b121a33 = ()=>{
    // Get session ID from the page context
    const sessionIdElement = document.querySelector('[data-session-id]');
    if (sessionIdElement) {
        const sessionId = sessionIdElement.dataset.sessionId;
        console.log('Session ID value:', sessionId);
        if (sessionId) {
            console.log('Initializing WebSocket with session ID:', sessionId);
            // Initialize WebSocket client
            window.kindeWebSocket = new KindeWebSocketClient(sessionId);
            // Clean up on page unload
            window.addEventListener('beforeunload', function() {
                if (window.kindeWebSocket) window.kindeWebSocket.disconnect();
            });
        } else {
            console.warn('No session ID available for WebSocket connection');
            console.log('Session ID element attributes:', sessionIdElement.attributes);
            console.log('Session ID element innerHTML:', sessionIdElement.innerHTML);
        }
    } else console.warn('Session ID element not found');
};
const $377f11a9d239d799$export$ad591f68158446c9 = ()=>{
    // Get session ID from the page context
    const sessionIdElement = document.querySelector('[data-session-id]');
    if (sessionIdElement) {
        const sessionId = sessionIdElement.dataset.sessionId;
        console.log('Session ID value:', sessionId);
        if (sessionId) {
            console.log('Initializing SSE with session ID:', sessionId);
            // Initialize SSE client
            window.kindeSSE = new (0, $65UhT.KindeSSEClient)(sessionId);
            // Clean up on page unload
            window.addEventListener('beforeunload', function() {
                if (window.kindeSSE) window.kindeSSE.disconnect();
            });
        } else {
            console.warn('No session ID available for SSE connection');
            console.log('Session ID element attributes:', sessionIdElement.attributes);
            console.log('Session ID element innerHTML:', sessionIdElement.innerHTML);
        }
    } else console.warn('Session ID element not found');
};

});
parcelRegister("gbP80", function(module, exports) {

$parcel$export(module.exports, "renderMakeResponse", function () { return $bc95556b71478e29$export$efc468fc4e3a7201; });
$parcel$export(module.exports, "renderUserPrompt", function () { return $bc95556b71478e29$export$5079699a67febf28; });

var $fnzEC = parcelRequire("fnzEC");

var $8sI4D = parcelRequire("8sI4D");

var $loPPx = parcelRequire("loPPx");

var $8OYHB = parcelRequire("8OYHB");

var $jcXHp = parcelRequire("jcXHp");
const $bc95556b71478e29$export$efc468fc4e3a7201 = (jobId, chatLogContainer)=>(res, data)=>{
        const { progress: progress } = res;
        const id = `${(0, $fnzEC.RESPONSE_ID_PREFIX)}${jobId}`;
        if (!chatLogContainer.querySelector(`#${id}`)) {
            const el = (0, $jcXHp.chatMessageEl)(false);
            el.id = id;
            // Create and append AI response
            const contentEl = (0, $jcXHp.markdownEl)();
            el.appendChild(contentEl);
            // Create and append tool status
            const toolStatusEl = (0, $jcXHp.toolsEl)();
            el.appendChild(toolStatusEl);
            // Initialize streaming renderer
            const streamingRenderer = (0, $8sI4D.createStreamingRenderer)(contentEl, el, {
                headingOffset: (0, $fnzEC.MARKDOWN_HEADING_OFFSET),
                renderDelay: 16
            });
            // Store renderer reference for cleanup
            el._streamingRenderer = streamingRenderer;
            el._toolStatusEl = toolStatusEl;
            el._toolItems = {};
            // Append to chat log
            chatLogContainer.appendChild(el);
        }
        const el = chatLogContainer.querySelector(`#${id}`);
        const streamingRenderer = el._streamingRenderer;
        const toolStatusEl = el._toolStatusEl;
        const toolItems = el._toolItems || {};
        const getFileName = (path)=>{
            if (!path) return '';
            const parts = String(path).split('/');
            return parts[parts.length - 1] || String(path);
        };
        const setToolItemVariant = (itemObj, variant)=>{
            const el = itemObj.el;
            el.classList.remove('is-success', 'is-error', 'is-info');
            switch(variant){
                case 'success':
                    el.classList.add('is-success');
                    break;
                case 'error':
                    el.classList.add('is-error');
                    break;
                case 'info':
                    el.classList.add('is-info');
                    break;
            }
        };
        const ensureToolItem = (key)=>{
            if (toolItems[key]) return toolItems[key];
            const toolItem = (0, $jcXHp.toolItemEl)();
            if (toolStatusEl) {
                toolStatusEl.appendChild(toolItem.root);
                toolItem.root.scrollIntoView();
            }
            toolItems[key] = {
                el: toolItem.root,
                spinner: toolItem.spinner,
                text: toolItem.text
            };
            el._toolItems = toolItems;
            return toolItems[key];
        };
        const ensureJobItem = ()=>{
            if (el._jobItem) return el._jobItem;
            const jobItem = (0, $jcXHp.toolItemEl)();
            if (toolStatusEl) {
                toolStatusEl.appendChild(jobItem.root);
                jobItem.root.scrollIntoView();
            }
            el._jobItem = {
                el: jobItem.root,
                spinner: jobItem.spinner,
                text: jobItem.text
            };
            return el._jobItem;
        };
        const setToolItemText = (tool, status, path)=>{
            const file = getFileName(path);
            switch(tool){
                case 'createOrUpdateFile':
                    if (status === 'success') return `Edited ${file}`;
                    if (status === 'error') return `Failed editing ${file}`;
                    return file ? `Editing ${file}\u{2026}` : "Editing\u2026";
                case 'readFile':
                    return status === 'success' ? `Read file ${file}` : "Reading file\u2026";
                case 'writeFile':
                    return status === 'success' ? `Wrote ${file}` : `Writing ${file}`;
                case 'appendToFile':
                    return status === 'success' ? `Appended to ${file}` : "Appending to file\u2026";
                case 'stringReplace':
                    return status === 'success' ? `Replaced text in ${file}` : "Replacing text\u2026";
                case 'snapshotProjectFiles':
                    return status === 'success' ? 'Scanned project files' : "Scanning project files\u2026";
                default:
                    return status === 'success' ? 'Done' : "Working\u2026";
            }
        };
        if (progress && progress.length > 0) {
            progress.forEach((item)=>{
                const progress = item.progress || {};
                // Update tool item based on tool progress events
                if (progress.event === 'tool_progress') {
                    const { tool_name: tool_name, status: status, message: message, path: path, bytes: bytes, project_hash: project_hash } = progress;
                    console.log(`[tool] ${tool_name || 'unknown'}: ${status || 'info'} - ${message || ''}`, {
                        path: path,
                        bytes: bytes,
                        project_hash: project_hash
                    });
                    const key = `${tool_name || 'tool'}:${path || ''}`;
                    const item = ensureToolItem(key);
                    item.text.textContent = setToolItemText(tool_name, status, path);
                    item.spinner.style.display = status === 'success' || status === 'error' ? 'none' : '';
                    switch(status){
                        case 'start':
                            setToolItemVariant(item, 'info');
                            break;
                        case 'success':
                            setToolItemVariant(item, 'success');
                            break;
                        case 'error':
                            setToolItemVariant(item, 'error');
                            break;
                    }
                }
                if (progress.event === 'job_status') {
                    const { status: status, message: message } = progress;
                    console.log(`[job] ${status} - ${message || ''}`);
                    const item = ensureJobItem();
                    if (status === 'building') item.text.textContent = `Build in progress\u{2026}`;
                    if (status === 'build_completed_successfully') {
                        item.text.textContent = `Build completed successfully`;
                        item.spinner.style.display = 'none';
                    }
                    if (status === 'build_failed') {
                        setToolItemVariant(item, 'error');
                        item.text.textContent = `Build failed. ${message}`;
                        item.spinner.style.display = 'none';
                    }
                }
                if (progress.event === 'planner_status') {
                    const { status: status, message: message } = progress;
                    const item = ensureJobItem();
                    if (status === 'thinking') item.text.textContent = message || "Thinking\u2026";
                }
                // Suppress verbose backend text per updated UI
                if (streamingRenderer && !streamingRenderer.isFinalized() && progress.delta) streamingRenderer.appendDelta(progress.delta);
            });
            data.set('p_last_progress', progress[progress.length - 1].id);
        }
        return {
            ok: true,
            data: data
        };
    };
const $bc95556b71478e29$export$5079699a67febf28 = async (prompt, chatLogContainer)=>{
    const el = (0, $jcXHp.chatMessageEl)();
    const contentEl = (0, $jcXHp.markdownEl)();
    el.appendChild(contentEl);
    const markedInstance = await (0, $loPPx.initMarked)((0, $fnzEC.MARKDOWN_HEADING_OFFSET));
    const escapedPrompt = (0, $8OYHB.escapeHtml)(prompt);
    contentEl.innerHTML = await (0, $loPPx.renderMarkdown)(escapedPrompt, markedInstance);
    chatLogContainer.appendChild(el);
    el.scrollIntoView();
};

});
parcelRegister("fnzEC", function(module, exports) {

$parcel$export(module.exports, "RESPONSE_ID_PREFIX", function () { return $b324a9254c0b2ec0$export$3eabbc1ba418ca00; });
$parcel$export(module.exports, "MARKDOWN_HEADING_OFFSET", function () { return $b324a9254c0b2ec0$export$f271d09797150452; });
const $b324a9254c0b2ec0$export$3eabbc1ba418ca00 = 'id_make_response_';
const $b324a9254c0b2ec0$export$f271d09797150452 = 3;

});

parcelRegister("8sI4D", function(module, exports) {

$parcel$export(module.exports, "createStreamingRenderer", function () { return $629320641e7aff05$export$e3a1c8636eaf2fa6; });

var $laGbt = parcelRequire("laGbt");

var $loPPx = parcelRequire("loPPx");

var $8OYHB = parcelRequire("8OYHB");
// Markdown token patterns for incremental parsing
const $629320641e7aff05$var$MARKDOWN_PATTERNS = {
    heading: /^(#{1,6})\s/,
    bold: /\*\*([^*]+)\*\*/g,
    blockquote: /^>\s?(.*)/gm,
    italic: /\*([^*]+)\*/g,
    code: /`([^`]+)`/g,
    codeBlock: /```[\s\S]*?```/g,
    list: /^(\s*)([-*+]|\d+\.)\s/,
    link: /\[([^\]]+)\]\(([^)]+)\)/g,
    lineBreak: /\n/g
};
// Check if a markdown element is complete
const $629320641e7aff05$var$isElementComplete = (text, pattern)=>{
    if (pattern === $629320641e7aff05$var$MARKDOWN_PATTERNS.heading) return /\n/.test(text) || text.length > 100;
    if (pattern === $629320641e7aff05$var$MARKDOWN_PATTERNS.bold) return (text.match(/\*\*/g) || []).length % 2 === 0;
    if (pattern === $629320641e7aff05$var$MARKDOWN_PATTERNS.blockquote) // Consider blockquote complete if the text includes an empty quote line
    // or a double line break
    return /\n\s*>?\s*\n/.test(text) || /\n{2,}/.test(text);
    if (pattern === $629320641e7aff05$var$MARKDOWN_PATTERNS.italic) return (text.match(/\*/g) || []).length % 2 === 0;
    if (pattern === $629320641e7aff05$var$MARKDOWN_PATTERNS.code) return (text.match(/`/g) || []).length % 2 === 0;
    if (pattern === $629320641e7aff05$var$MARKDOWN_PATTERNS.codeBlock) return text.includes('```') && (text.match(/```/g) || []).length % 2 === 0;
    if (pattern === $629320641e7aff05$var$MARKDOWN_PATTERNS.list) return /\n/.test(text) && !text.match(/^(\s*)([-*+]|\d+\.)\s/);
    if (pattern === $629320641e7aff05$var$MARKDOWN_PATTERNS.link) return text.includes('](') && text.includes(')');
    return true; // Default to complete
};
// Create incremental markdown renderer
const $629320641e7aff05$var$createIncrementalRenderer = (el, options = {})=>{
    const { headingOffset: headingOffset, maxBufferSize: maxBufferSize = 10000 } = options;
    let buffer = '';
    let renderTimeout = null;
    let markedInstance = null;
    let isFinalized = false;
    const init = async ()=>{
        markedInstance = await (0, $loPPx.initMarked)(headingOffset);
    };
    // Process buffer and render complete elements
    const processBuffer = async ()=>{
        if (isFinalized || buffer.length === 0) return;
        let processedText = '';
        let remainingText = buffer;
        let hasChanges = false;
        // Process each markdown pattern
        for (const [, pattern] of Object.entries($629320641e7aff05$var$MARKDOWN_PATTERNS))if ($629320641e7aff05$var$isElementComplete(remainingText, pattern)) {
            const escapedResponse = (0, $8OYHB.escapeHtml)(remainingText);
            const processed = await (0, $loPPx.renderMarkdown)(escapedResponse, markedInstance);
            if (processed !== remainingText) {
                processedText = processed;
                remainingText = '';
                hasChanges = true;
            }
        }
        // If no patterns matched or elements are incomplete, keep as plain text
        if (!hasChanges) processedText = remainingText;
        // Update element content
        if (processedText !== el.innerHTML) el.innerHTML = processedText;
    };
    // Schedule rendering with requestAnimationFrame
    const scheduleRender = ()=>{
        if (renderTimeout) cancelAnimationFrame(renderTimeout);
        renderTimeout = requestAnimationFrame(async ()=>{
            await processBuffer();
            renderTimeout = null;
        });
    };
    // Add text delta to buffer
    const appendDelta = (delta)=>{
        if (isFinalized) return;
        buffer += delta;
        // Prevent buffer from growing too large
        if (buffer.length > maxBufferSize) buffer = buffer.slice(-maxBufferSize / 2);
        scheduleRender();
    };
    // Finalize rendering - process any remaining incomplete elements
    const finalize = async ()=>{
        isFinalized = true;
        if (renderTimeout) {
            cancelAnimationFrame(renderTimeout);
            renderTimeout = null;
        }
        // Force final render with complete buffer
        await processBuffer();
        // Clean up
        buffer = '';
    };
    // Initialise Marked
    init();
    return {
        appendDelta: appendDelta,
        finalize: finalize,
        getBuffer: ()=>buffer,
        isFinalized: ()=>isFinalized
    };
};
// Create streaming markdown renderer for chat responses
const $629320641e7aff05$export$e3a1c8636eaf2fa6 = (el, elContainer, options = {})=>{
    const renderer = $629320641e7aff05$var$createIncrementalRenderer(el, options);
    return {
        ...renderer,
        // Override appendDelta to handle streaming-specific logic
        appendDelta: (delta)=>{
            renderer.appendDelta(delta);
            // Auto-scroll to keep content visible
            elContainer.scrollIntoView({
                behavior: 'smooth',
                block: 'end'
            });
        }
    };
};
// Register the component
const $629320641e7aff05$export$4d4ac63ee0f3c755 = ()=>{
    (0, $laGbt.register)('incrementalMarkdown', {
        createRenderer: $629320641e7aff05$var$createIncrementalRenderer,
        createStreamingRenderer: $629320641e7aff05$export$e3a1c8636eaf2fa6
    });
};

});
parcelRegister("loPPx", function(module, exports) {

$parcel$export(module.exports, "initMarked", function () { return $f9440b43c93a8b64$export$c701709149744cd2; });
$parcel$export(module.exports, "renderMarkdown", function () { return $f9440b43c93a8b64$export$bd27f0c8b4b4eabc; });

var $1Wath = parcelRequire("1Wath");

var $egNEx = parcelRequire("egNEx");

var $8OYHB = parcelRequire("8OYHB");
let $f9440b43c93a8b64$var$markedInstance = null;



const $f9440b43c93a8b64$export$c701709149744cd2 = async (headingOffset = 1)=>{
    if ($f9440b43c93a8b64$var$markedInstance) return $f9440b43c93a8b64$var$markedInstance;
    try {
        const { marked: marked } = await (parcelRequire("1K7Y0"));
        const { sanitize: sanitize } = await (parcelRequire("7eO1E"));
        await (parcelRequire("6V0jb"));
        const config = (0, $egNEx.createConfig)(headingOffset);
        marked.use(config);
        $f9440b43c93a8b64$var$markedInstance = {
            marked: marked,
            sanitize: sanitize
        };
        return $f9440b43c93a8b64$var$markedInstance;
    } catch (error) {
        console.warn('Marked and DOMPurify libraries not available:', error);
        return null;
    }
};
const $f9440b43c93a8b64$export$bd27f0c8b4b4eabc = async (text, instance = $f9440b43c93a8b64$var$markedInstance)=>{
    if (instance?.marked && instance?.sanitize) {
        const html = instance.marked.parse(text);
        const safeHtml = instance.sanitize(html);
        // Create temporary element to find and highlight code blocks
        const tempEl = document.createElement('div');
        tempEl.innerHTML = safeHtml;
        // Initialise Prism on any code blocks with language class
        const codeBlocks = tempEl.querySelectorAll('code[class*="language-"]');
        if (codeBlocks.length) await Promise.all([
            ...codeBlocks
        ].map((0, $1Wath.init)));
        return tempEl.innerHTML;
    }
    // Fallback to simple HTML escaping
    return (0, $8OYHB.escapeHtml)(text);
};

});
parcelRegister("1Wath", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $1693549fa50b558c$export$2cd8252107eb640b; });

var $55iRN = parcelRequire("55iRN");

var $97kDM = parcelRequire("97kDM");


const $1693549fa50b558c$export$2cd8252107eb640b = async (codeEl)=>{
    if (!codeEl) {
        console.warn('No `code` element provided to Prism initialisation');
        return;
    }
    const Prism = await (parcelRequire("4gggN"));
    await (parcelRequire("ay4vi"));
    const lang = (0, $55iRN.extractLang)(codeEl);
    await (0, $55iRN.loadLang)(lang);
    if ((0, $97kDM.hasLineNumbers)(codeEl)) await (0, $97kDM.loadLineNumbers)();
    Prism.highlightElement(codeEl);
};

});
parcelRegister("55iRN", function(module, exports) {

$parcel$export(module.exports, "extractLang", function () { return $3b3c0de4e27eded0$export$a20026ec9b748604; });
$parcel$export(module.exports, "loadLang", function () { return $3b3c0de4e27eded0$export$f938203cbf207701; });

var $8WWep = parcelRequire("8WWep");
const $3b3c0de4e27eded0$var$LANGUAGE_ALIASES = {
    js: 'javascript',
    ts: 'typescript',
    py: 'python',
    rb: 'ruby',
    html: 'markup',
    xml: 'markup',
    sh: 'bash',
    shell: 'bash',
    yml: 'yaml',
    md: 'markdown',
    csharp: 'cs',
    cpp: 'c'
};
const $3b3c0de4e27eded0$export$a20026ec9b748604 = (el)=>{
    const classes = el.className.split(' ');
    const langClass = classes.find((cls)=>cls.startsWith('language-'));
    return langClass?.replace('language-', '');
};
const $3b3c0de4e27eded0$export$f938203cbf207701 = async (lang)=>{
    // Map aliases to canonical Prism language
    const canonicalLang = $3b3c0de4e27eded0$var$LANGUAGE_ALIASES[lang] || lang;
    // Skip plaintext since it's just the fallback
    if (canonicalLang === 'plaintext') return;
    // Skip loading for core languages that aren't dependencies
    if ((0, $8WWep.CORE_LANGUAGES).includes(canonicalLang) && !(0, $8WWep.LANGUAGE_MODULE_MAP)[canonicalLang]) return;
    // Get dependencies for this language
    const dependencies = (0, $8WWep.LANGUAGE_DEPENDENCIES)[canonicalLang] || [];
    // Load dependencies first
    for (const dep of dependencies)await $3b3c0de4e27eded0$export$f938203cbf207701(dep);
    // Then load the language itself
    const loader = (0, $8WWep.LANGUAGE_MODULE_MAP)[canonicalLang];
    if (loader) try {
        await loader();
    } catch (err) {
        console.warn(`Failed to load Prism language '${canonicalLang}':`, err);
    }
};

});
parcelRegister("8WWep", function(module, exports) {

$parcel$export(module.exports, "CORE_LANGUAGES", function () { return $6840e910a904437e$export$c95411500b68d2ce; });
$parcel$export(module.exports, "LANGUAGE_MODULE_MAP", function () { return $6840e910a904437e$export$938d983a9040eb51; });
$parcel$export(module.exports, "LANGUAGE_DEPENDENCIES", function () { return $6840e910a904437e$export$f85d6258285ce6c; });
// Core languages that come bundled with Prism
const $6840e910a904437e$export$c95411500b68d2ce = [
    'clike',
    'css',
    'html',
    'markup',
    'mathml',
    'svg',
    'xml'
];














const $6840e910a904437e$export$938d983a9040eb51 = {
    // Core language needed as dependency
    javascript: ()=>(parcelRequire("7Cyfa")),
    // Additional/custom languages
    bash: ()=>(parcelRequire("ar2Si")),
    graphql: ()=>(parcelRequire("fgjNn")),
    ini: ()=>(parcelRequire("5wbmO")),
    json: ()=>(parcelRequire("5ch2Z")),
    json5: ()=>(parcelRequire("iIJwX")),
    jsx: ()=>(parcelRequire("97KBo")),
    makefile: ()=>(parcelRequire("dJeMq")),
    markdown: ()=>(parcelRequire("1JP1n")),
    scss: ()=>(parcelRequire("kicF7")),
    sql: ()=>(parcelRequire("7KYYD")),
    tsx: ()=>(parcelRequire("1LV0f")),
    typescript: ()=>(parcelRequire("l1YXD")),
    yaml: ()=>(parcelRequire("jSEJB"))
};
const $6840e910a904437e$export$f85d6258285ce6c = {
    json: [
        'javascript'
    ],
    json5: [
        'json'
    ],
    jsx: [
        'javascript'
    ],
    tsx: [
        'typescript',
        'jsx'
    ],
    typescript: [
        'javascript'
    ]
};

});
parcelRegister("7Cyfa", function(module, exports) {

module.exports = (parcelRequire("8IOE6"))($parcel$resolve("hVd95")).then(()=>parcelRequire('jZ49y'));

});
parcelRegister("8IOE6", function(module, exports) {
"use strict";

var $irO82 = parcelRequire("irO82");
module.exports = $irO82(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("irO82", function(module, exports) {
"use strict";
var $d6e1a220cea75696$var$cachedBundles = {};
var $d6e1a220cea75696$var$cachedPreloads = {};
var $d6e1a220cea75696$var$cachedPrefetches = {};
function $d6e1a220cea75696$var$getCache(type) {
    switch(type){
        case 'preload':
            return $d6e1a220cea75696$var$cachedPreloads;
        case 'prefetch':
            return $d6e1a220cea75696$var$cachedPrefetches;
        default:
            return $d6e1a220cea75696$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $d6e1a220cea75696$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("ar2Si", function(module, exports) {

module.exports = (parcelRequire("8IOE6"))($parcel$resolve("5XAWp")).then(()=>parcelRequire('3SFNp'));

});

parcelRegister("fgjNn", function(module, exports) {

module.exports = (parcelRequire("8IOE6"))($parcel$resolve("5vWgD")).then(()=>parcelRequire('ec1PW'));

});

parcelRegister("5wbmO", function(module, exports) {

module.exports = (parcelRequire("8IOE6"))($parcel$resolve("6ijNy")).then(()=>parcelRequire('bMny1'));

});

parcelRegister("5ch2Z", function(module, exports) {

module.exports = (parcelRequire("8IOE6"))($parcel$resolve("3dcDw")).then(()=>parcelRequire('1eLQZ'));

});

parcelRegister("iIJwX", function(module, exports) {

module.exports = (parcelRequire("8IOE6"))($parcel$resolve("38KM7")).then(()=>parcelRequire('f2eyU'));

});

parcelRegister("97KBo", function(module, exports) {

module.exports = (parcelRequire("8IOE6"))($parcel$resolve("j6z8i")).then(()=>parcelRequire('cVugQ'));

});

parcelRegister("dJeMq", function(module, exports) {

module.exports = (parcelRequire("8IOE6"))($parcel$resolve("akuxC")).then(()=>parcelRequire('g8hgl'));

});

parcelRegister("1JP1n", function(module, exports) {

module.exports = (parcelRequire("8IOE6"))($parcel$resolve("6bD26")).then(()=>parcelRequire('4T4hn'));

});

parcelRegister("kicF7", function(module, exports) {

module.exports = (parcelRequire("8IOE6"))($parcel$resolve("km5HQ")).then(()=>parcelRequire('iNCnh'));

});

parcelRegister("7KYYD", function(module, exports) {

module.exports = (parcelRequire("8IOE6"))($parcel$resolve("iFOQB")).then(()=>parcelRequire('ftvw9'));

});

parcelRegister("1LV0f", function(module, exports) {

module.exports = (parcelRequire("8IOE6"))($parcel$resolve("knggI")).then(()=>parcelRequire('8yz4j'));

});

parcelRegister("l1YXD", function(module, exports) {

module.exports = (parcelRequire("8IOE6"))($parcel$resolve("foaYQ")).then(()=>parcelRequire('kcp5P'));

});

parcelRegister("jSEJB", function(module, exports) {

module.exports = (parcelRequire("8IOE6"))($parcel$resolve("d5GAD")).then(()=>parcelRequire('57Q60'));

});



parcelRegister("97kDM", function(module, exports) {

$parcel$export(module.exports, "hasLineNumbers", function () { return $6a34c74e16f459c1$export$cc00c6295f772ada; });
$parcel$export(module.exports, "loadLineNumbers", function () { return $6a34c74e16f459c1$export$78f5b955cfd34e38; });
const $6a34c74e16f459c1$export$cc00c6295f772ada = (el)=>el.classList.contains('line-numbers');


const $6a34c74e16f459c1$export$78f5b955cfd34e38 = async ()=>{
    try {
        await (parcelRequire("dqpWl"));
        await (parcelRequire("6Z4OC"));
    } catch (err) {
        console.warn('Failed to load Prism line numbers plugin:', err);
    }
};

});
parcelRegister("dqpWl", function(module, exports) {

module.exports = (parcelRequire("8IOE6"))($parcel$resolve("6rIAR")).then(()=>parcelRequire('kBvfX'));

});

parcelRegister("6Z4OC", function(module, exports) {

module.exports = (parcelRequire("gmhUp"))($parcel$resolve("7tFEa"));

});
parcelRegister("gmhUp", function(module, exports) {
"use strict";

var $irO82 = parcelRequire("irO82");
module.exports = $irO82(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});



parcelRegister("4gggN", function(module, exports) {

module.exports = (parcelRequire("8IOE6"))($parcel$resolve("2iHFc")).then(()=>parcelRequire('dgrzF'));

});

parcelRegister("ay4vi", function(module, exports) {

module.exports = (parcelRequire("gmhUp"))($parcel$resolve("7xNLC"));

});


parcelRegister("egNEx", function(module, exports) {

$parcel$export(module.exports, "createConfig", function () { return $a6391355cb5e46cb$export$45a69314cf48a3eb; });
const $a6391355cb5e46cb$export$45a69314cf48a3eb = (headingOffset)=>({
        breaks: true,
        gfm: true,
        renderer: {
            codespan ({ text: text }) {
                return `<code class="kui-util-code-inline kui-util-type-mono-2">${text}</code>`;
            },
            code ({ text: text, lang: lang }) {
                const langClass = lang ? `language-${lang}` : '';
                const langLabel = lang ? `<p class="kui-util-type-body-caption">${lang}</p>` : '';
                return `
                <div class="c-marked-code-block">
                    <pre>${langLabel}<code class="${langClass}">${text}</code></pre>
                </div>
            `;
            },
            heading ({ tokens: tokens, depth: depth }) {
                const classMap = {
                    2: 'kui-util-type-headline-3',
                    3: 'kui-util-type-headline-4',
                    4: 'kui-util-type-headline-5',
                    5: 'kui-util-type-subhead-1',
                    6: 'kui-util-type-subhead-1'
                };
                const text = this.parser.parseInline(tokens);
                let level = depth + headingOffset;
                // Clamp to valid range
                if (level <= 1) level = 2;
                if (level > 6) level = 6;
                const cssClass = classMap[level] || '';
                return `<h${level} class="${cssClass}">${text}</h${level}>`;
            },
            image () {
                return ''; // Block all images
            },
            link ({ href: href, title: title, text: text }) {
                const titleAttr = title ? `title="${title}"` : '';
                return `<a href="${href}" ${titleAttr} class="kui-util-link-1">${text}</a>`;
            }
        }
    });

});

parcelRegister("8OYHB", function(module, exports) {

$parcel$export(module.exports, "escapeHtml", function () { return $66c2146dd0d0db0b$export$4cf11838cdc2a8a8; });
$parcel$export(module.exports, "decodeBlockquotes", function () { return $66c2146dd0d0db0b$export$a6db77453c1bbdc2; });
const $66c2146dd0d0db0b$export$4cf11838cdc2a8a8 = (text)=>String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
const $66c2146dd0d0db0b$export$a6db77453c1bbdc2 = (text)=>text.replace(/&gt;/g, '>');

});

parcelRegister("1K7Y0", function(module, exports) {

module.exports = (parcelRequire("8IOE6"))($parcel$resolve("e8zl5")).then(()=>parcelRequire('gjSVA'));

});

parcelRegister("7eO1E", function(module, exports) {

module.exports = (parcelRequire("8IOE6"))($parcel$resolve("73tvQ")).then(()=>parcelRequire('4DUyl'));

});

parcelRegister("6V0jb", function(module, exports) {

module.exports = (parcelRequire("gmhUp"))($parcel$resolve("g7N4e"));

});



parcelRegister("jcXHp", function(module, exports) {

$parcel$export(module.exports, "chatMessageEl", function () { return $dfbd724ebafd619f$export$f3c518915b6fcbd3; });
$parcel$export(module.exports, "markdownEl", function () { return $dfbd724ebafd619f$export$c90eaf73b7bf1e5f; });
$parcel$export(module.exports, "spinnerEl", function () { return $dfbd724ebafd619f$export$caa0e4051b967e58; });
$parcel$export(module.exports, "toolsEl", function () { return $dfbd724ebafd619f$export$7a1444c33dec7222; });
$parcel$export(module.exports, "toolItemEl", function () { return $dfbd724ebafd619f$export$43b4c01c74f489ea; });
const $dfbd724ebafd619f$export$f3c518915b6fcbd3 = (isUserPrompt = true)=>{
    const el = document.createElement('div');
    el.classList.add('kui-chat-message', ...isUserPrompt ? [
        'is-user',
        'is-latest'
    ] : [
        'is-response'
    ]);
    el.setAttribute('role', 'group');
    return el;
};
const $dfbd724ebafd619f$export$c90eaf73b7bf1e5f = ()=>{
    const el = document.createElement('div');
    el.dataset.marked = 'true';
    el.dataset.markedSpacing = 'small';
    return el;
};
const $dfbd724ebafd619f$export$caa0e4051b967e58 = (isSmall)=>{
    const el = document.createElement('span');
    el.dataset.kuiSpinner = 'true';
    el.className = 'kui-spinner';
    el.setAttribute('aria-hidden', 'true');
    if (isSmall) el.classList.add('kui-spinner--size-small');
    const elContents = `
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <g
                fill="transparent"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-width="8px"
            >
                <circle cx="50" cy="50" r="45"></circle>
                <circle cx="50" cy="50" r="45"></circle>
            </g>
        </svg>
    `;
    el.innerHTML = elContents;
    return el;
};
const $dfbd724ebafd619f$export$7a1444c33dec7222 = ()=>{
    const el = document.createElement('div');
    el.classList.add('kui-chat-message__tools');
    return el;
};
const $dfbd724ebafd619f$export$43b4c01c74f489ea = ()=>{
    const root = document.createElement('div');
    const spinner = $dfbd724ebafd619f$export$caa0e4051b967e58();
    const text = document.createElement('p');
    root.classList.add('kui-chat-message__tool-item');
    root.appendChild(spinner);
    root.appendChild(text);
    return {
        root: root,
        spinner: spinner,
        text: text
    };
};

});


parcelRegister("hZoxd", function(module, exports) {

$parcel$export(module.exports, "longPoll", function () { return $d18b2a4941d709c1$export$291234df4f8bb0a8; });
$parcel$export(module.exports, "poll", function () { return $d18b2a4941d709c1$export$e0c10349b2c5e1d4; });

var $laGbt = parcelRequire("laGbt");

var $fHULH = parcelRequire("fHULH");

var $1UkIB = parcelRequire("1UkIB");
const $d18b2a4941d709c1$var$updateUI = (id)=>(res, data)=>{
        const progressBar = document.querySelector(`[kui-poll-progress-id="${id}"]`);
        const progressPercentDisplay = document.querySelector(`[kui-poll-progress-value-indicator]`);
        const progressPercentValue = Math.floor(res.progress);
        if (progressBar) progressBar.value = progressPercentValue;
        if (progressPercentDisplay) progressPercentDisplay.innerText = `${progressPercentValue}% `;
        return {
            ok: true,
            data: data
        };
    };
const $d18b2a4941d709c1$var$allowedUrls = [
    '/import/import_poll',
    '/business/export_poll',
    '/progress/delay',
    '/make/progress'
];
// Track active polling requests and controllers
const $d18b2a4941d709c1$var$activePolls = new Map();
async function $d18b2a4941d709c1$export$291234df4f8bb0a8(url, data, callback, retryCount = 0, maxRetries = 5) {
    // Generate unique ID for this polling session
    const pollId = Math.random().toString(36).slice(2);
    // Create abort controller for this request
    const controller = new AbortController();
    $d18b2a4941d709c1$var$activePolls.set(pollId, controller);
    const csrfToken = document.head.querySelector('[name=csrf-token][content]').content;
    if (!$d18b2a4941d709c1$var$allowedUrls.includes(url)) return;
    try {
        const response = await fetch(url, {
            method: 'POST',
            body: data,
            headers: {
                Accept: 'roast/mixed',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': csrfToken
            },
            signal: controller.signal // Add abort signal
        });
        if (response.status !== 200) {
            if (retryCount < maxRetries) {
                if (response.status === 502) // Timeout error so try to reconnect
                await $d18b2a4941d709c1$export$291234df4f8bb0a8(url, data, callback, retryCount + 1);
                else {
                    console.error(response.statusText);
                    // General error. Reconnect in 1 second
                    await new Promise((resolve)=>setTimeout(resolve, 1000));
                    await $d18b2a4941d709c1$export$291234df4f8bb0a8(url, data, callback, retryCount + 1);
                }
            } else console.error('Max retries exceeded');
        } else {
            // Success
            const res = await (0, $1UkIB.handleResponse)(response);
            if (res && res.action === 'polling') {
                const result = callback(res, data);
                if (result.ok) {
                    // Check again in 250ms
                    await new Promise((resolve)=>setTimeout(resolve, 250));
                    // Only continue polling if not cancelled
                    if ($d18b2a4941d709c1$var$activePolls.has(pollId)) await $d18b2a4941d709c1$export$291234df4f8bb0a8(url, result.data, callback);
                }
            }
        }
    } catch (err) {
        if (err.name === 'AbortError') console.log('Polling cancelled');
        else console.error(err);
    } finally{
        // Clean up controller reference
        $d18b2a4941d709c1$var$activePolls.delete(pollId);
    }
    return pollId;
}
// Add cancel method to longPoll
$d18b2a4941d709c1$export$291234df4f8bb0a8.cancel = (pollId)=>{
    if (pollId) {
        // Cancel specific poll
        const controller = $d18b2a4941d709c1$var$activePolls.get(pollId);
        if (controller) {
            controller.abort();
            $d18b2a4941d709c1$var$activePolls.delete(pollId);
        }
    } else {
        // Cancel all active polls
        $d18b2a4941d709c1$var$activePolls.forEach((controller)=>controller.abort());
        $d18b2a4941d709c1$var$activePolls.clear();
    }
};
const $d18b2a4941d709c1$var$start = (el)=>{
    const { pollUrl: pollUrl, pollProgressId: pollProgressId } = (0, $fHULH.kuiset)(el);
    const formData = new FormData();
    Object.entries((0, $fHULH.kuiset)(el)).forEach(([key, value])=>{
        if (key.includes('pollParam')) formData.append(key.replace('pollParam', '').toLowerCase(), value);
    });
    if ($d18b2a4941d709c1$var$allowedUrls.includes(pollUrl)) $d18b2a4941d709c1$export$291234df4f8bb0a8(pollUrl, formData, $d18b2a4941d709c1$var$updateUI(pollProgressId));
};
const $d18b2a4941d709c1$export$e0c10349b2c5e1d4 = ()=>{
    (0, $laGbt.register)('poll', {
        start: $d18b2a4941d709c1$var$start
    });
};

});
parcelRegister("fHULH", function(module, exports) {

$parcel$export(module.exports, "kuiset", function () { return $b6f6e82acc679bb9$export$8cc45b4c3329b37d; });

var $92Eyg = parcelRequire("92Eyg");
const $b6f6e82acc679bb9$var$hyphenToCamelCase = (str)=>str.replace(/\b-([a-z])/g, (all, char)=>char.toUpperCase());
const { length: $b6f6e82acc679bb9$var$LENGTH } = 'kui-';
const $b6f6e82acc679bb9$export$8cc45b4c3329b37d = (el)=>{
    const set = {};
    (0, $92Eyg.each)(el.attributes, (attribute)=>{
        const att = attribute.nodeName.toLowerCase();
        if (att.length >= $b6f6e82acc679bb9$var$LENGTH && att.substring(0, $b6f6e82acc679bb9$var$LENGTH) === 'kui-') set[$b6f6e82acc679bb9$var$hyphenToCamelCase(att.substring($b6f6e82acc679bb9$var$LENGTH, att.length))] = attribute.nodeValue;
    });
    return set;
};

});


parcelRegister("k6XfV", function(module, exports) {

$parcel$export(module.exports, "scrollToBottom", function () { return $ea42552e202cb609$export$64282f34fe8ec365; });
$parcel$export(module.exports, "chatLog", function () { return $ea42552e202cb609$export$b390bb66928e95d0; });

var $laGbt = parcelRequire("laGbt");
const $ea42552e202cb609$export$64282f34fe8ec365 = (el)=>{
    el.scrollTop = el.scrollHeight;
};
// Debounce helper to wait for rendering to settle
const $ea42552e202cb609$var$debounce = (fn, delay = 100)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>fn(...args), delay);
    };
};
const $ea42552e202cb609$var$scrollToBottomOnLoad = (el)=>{
    const lastMarkedMessage = el.querySelector('[data-marked]:last-child');
    if (!lastMarkedMessage) {
        $ea42552e202cb609$export$64282f34fe8ec365(el);
        return;
    }
    // Watch for both attribute changes and subtree modifications
    const observer = new MutationObserver($ea42552e202cb609$var$debounce(()=>{
        if (lastMarkedMessage.dataset.markedProcessed === 'true') {
            $ea42552e202cb609$export$64282f34fe8ec365(el);
            observer.disconnect();
        }
    }));
    observer.observe(lastMarkedMessage, {
        attributes: true,
        attributeFilter: [
            'data-marked-processed'
        ],
        subtree: true,
        childList: true // Watch for Prism modifications
    });
    // Initial check in case already processed
    if (lastMarkedMessage.dataset.markedProcessed === 'true') $ea42552e202cb609$export$64282f34fe8ec365(el);
};
const $ea42552e202cb609$export$b390bb66928e95d0 = ()=>{
    (0, $laGbt.register)('chatLog', {
        scrollToBottomOnLoad: $ea42552e202cb609$var$scrollToBottomOnLoad
    });
};

});

parcelRegister("65UhT", function(module, exports) {

$parcel$export(module.exports, "KindeSSEClient", function () { return $012524a1fbf5b740$export$1f07dbf760b199fa; });
// Simple SSE client for Kinde Make page
class $012524a1fbf5b740$export$1f07dbf760b199fa {
    constructor(sessionId){
        this.sessionId = sessionId;
        this.eventSource = null;
        this.reconnectAttempts = 0;
        this.maxReconnectAttempts = 5;
        this.reconnectDelay = 1000;
        this.connect();
    }
    connect() {
        try {
            // Connect to SSE endpoint
            const sseUrl = `/sse/${this.sessionId}`;
            console.log('Attempting to connect to SSE:', sseUrl);
            this.eventSource = new EventSource(sseUrl);
            this.eventSource.onopen = ()=>{
                console.log('SSE connected successfully');
                this.reconnectAttempts = 0;
                this.reconnectDelay = 1000;
            };
            this.eventSource.onmessage = (event)=>{
                console.log('SSE message received:', event.data);
                this.handleMessage(JSON.parse(event.data));
            };
            this.eventSource.addEventListener('connected', (event)=>{
                console.log('SSE connection event:', JSON.parse(event.data));
            });
            this.eventSource.addEventListener('heartbeat', (event)=>{
                return;
            });
            this.eventSource.addEventListener('notification', (event)=>{
                console.log('SSE notification received:', JSON.parse(event.data));
                this.handleNotification(JSON.parse(event.data));
            });
            this.eventSource.addEventListener('reload', (event)=>{
                console.log('SSE reload command received:', JSON.parse(event.data));
                this.handleReload(JSON.parse(event.data));
            });
            this.eventSource.onerror = (error)=>{
                console.error('SSE error:', error);
                this.attemptReconnect();
            };
        } catch (error) {
            console.error('Failed to create SSE connection:', error);
        }
    }
    handleMessage(message) {
        console.log('Processing SSE message:', message);
    }
    handleNotification(notification) {
        console.log('Processing notification:', notification);
    // TODO: Display notification in UI
    }
    handleReload(reloadCommand) {
        console.log('Processing reload command:', reloadCommand);
        // TODO: Implement page reload logic
        console.log('Reloading page...');
        const refreshEl = document.querySelector('[data-kui-project-refresh-trigger]');
        if (refreshEl) {
            console.log('Clicking refresh element');
            refreshEl.click();
        }
    }
    attemptReconnect() {
        if (this.reconnectAttempts < this.maxReconnectAttempts) {
            this.reconnectAttempts++;
            this.reconnectDelay *= 2; // Exponential backoff
            console.log(`Attempting to reconnect (${this.reconnectAttempts}/${this.maxReconnectAttempts}) in ${this.reconnectDelay}ms`);
            setTimeout(()=>{
                this.connect();
            }, this.reconnectDelay);
        } else console.error('Max reconnection attempts reached');
    }
    disconnect() {
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = null;
        }
    }
}
class $012524a1fbf5b740$export$9104ad2b86e9b1e3 {
    constructor(sessionId){
        this.sessionId = sessionId;
        this.connection = null;
        this.reconnectAttempts = 0;
        this.maxReconnectAttempts = 5;
        this.reconnectDelay = 1000;
        this.connect();
    }
    connect() {
        try {
            // Connect to WebSocket endpoint
            const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
            const wsUrl = `${protocol}//${window.location.host}/ws/${this.sessionId}`;
            console.log('Attempting to connect to WebSocket:', wsUrl);
            this.connection = new WebSocket(wsUrl);
            this.connection.onopen = ()=>{
                console.log('WebSocket connected successfully');
                this.reconnectAttempts = 0;
                this.reconnectDelay = 1000;
            };
            this.connection.onmessage = (event)=>{
                console.log('WebSocket message received:', event.data);
                this.handleMessage(JSON.parse(event.data));
            };
            this.connection.onclose = ()=>{
                console.log('WebSocket disconnected');
                this.attemptReconnect();
            };
            this.connection.onerror = (error)=>{
                console.error('WebSocket error:', error);
            };
        } catch (error) {
            console.error('Failed to create WebSocket connection:', error);
        }
    }
    handleMessage(message) {
        console.log('Processing WebSocket message:', message);
        // For now, just log everything as requested
        switch(message.type){
            case 'welcome':
                console.log('Welcome message received:', message.message, 'User ID:', message.user_id);
                break;
            case 'echo':
                console.log('Echo message received:', message.message);
                break;
            case 'test':
                console.log('Test message received:', message.message, 'Timestamp:', message.timestamp);
                break;
            default:
                console.log('Unknown message type:', message.type, 'Full message:', message);
        }
    }
    attemptReconnect() {
        if (this.reconnectAttempts < this.maxReconnectAttempts) {
            this.reconnectAttempts++;
            this.reconnectDelay *= 2; // Exponential backoff
            console.log(`Attempting to reconnect (${this.reconnectAttempts}/${this.maxReconnectAttempts}) in ${this.reconnectDelay}ms`);
            setTimeout(()=>{
                this.connect();
            }, this.reconnectDelay);
        } else console.error('Max reconnection attempts reached');
    }
    disconnect() {
        if (this.connection) this.connection.close();
    }
    // Test function to send a message
    sendTestMessage(message) {
        if (this.connection && this.connection.readyState === WebSocket.OPEN) {
            this.connection.send(message);
            console.log('Test message sent:', message);
        } else console.error('WebSocket not connected');
    }
}
// Global instance for testing (for backward compatibility)
window.KindeWebSocketClient = $012524a1fbf5b740$export$9104ad2b86e9b1e3;

});


parcelRegister("hOfxh", function(module, exports) {

$parcel$export(module.exports, "handleTreeViewItemClick", function () { return $cf732846c258c36a$export$17807f1eefa3a569; });
$parcel$export(module.exports, "loadInitialFileContent", function () { return $cf732846c258c36a$export$81e4b5add1c426; });

var $1Wath = parcelRequire("1Wath");

var $jcXHp = parcelRequire("jcXHp");
const $cf732846c258c36a$var$getLangFromFile = (name, ext)=>{
    // Handle extension-less files and patterns first
    if (/^(M|m)akefile$/.test(name)) return 'makefile';
    if (name.startsWith('.env') || name === '.editorconfig') return 'ini';
    if (name.endsWith('rc')) return 'json';
    // Handle by file extension
    switch(ext){
        // Core languages
        case 'c':
        case 'cpp':
        case 'cc':
        case 'h':
        case 'hpp':
            return 'clike';
        case 'css':
        case 'pcss':
            return 'css';
        case 'htm':
        case 'html':
        case 'xhtml':
        case 'xml':
        case 'svg':
        case 'mml':
        case 'mathml':
            return 'markup';
        // JavaScript family
        case 'jsx':
            return 'jsx';
        case 'tsx':
            return 'tsx';
        case 'ts':
        case 'cts':
        case 'mts':
            return 'typescript';
        case 'js':
        case 'cjs':
        case 'mjs':
            return 'javascript';
        // JSON family
        case 'json5':
            return 'json5';
        case 'json':
        case 'jsonc':
        case 'geojson':
            return 'json';
        // Other languages with multiple extensions
        case 'bash':
        case 'sh':
        case 'zsh':
            return 'bash';
        case 'gql':
        case 'graphql':
            return 'graphql';
        case 'ini':
        case 'conf':
        case 'config':
            return 'ini';
        case 'md':
        case 'markdown':
        case 'mdown':
            return 'markdown';
        case 'sql':
        case 'pgsql':
        case 'psql':
            return 'sql';
        case 'yml':
        case 'yaml':
            return 'yaml';
        // Single extensions
        case 'scss':
            return 'scss';
        // Fallback
        default:
            return 'plaintext';
    }
};
const $cf732846c258c36a$var$handleFetchLoading = (isActive, treeViewItemEl, fileContentEl)=>{
    const treeViewEl = treeViewItemEl.closest('[data-kui-tree-view]');
    const previewEl = fileContentEl.closest('[data-kui-code-file-preview]');
    if (!treeViewEl && !previewEl) {
        console.warn('No tree view or preview element found');
        return;
    }
    treeViewEl.setAttribute('aria-busy', isActive ? 'true' : 'false');
    previewEl.setAttribute('aria-busy', isActive ? 'true' : 'false');
    // Handle spinner
    if (isActive) {
        const spinner = (0, $jcXHp.spinnerEl)();
        previewEl.appendChild(spinner);
    } else {
        const existingSpinnerEl = previewEl.querySelector('[data-kui-spinner]');
        existingSpinnerEl?.remove();
    }
};
const $cf732846c258c36a$var$fetchAndRenderFile = async (fileRelPath, treeViewItemEl = null)=>{
    if (!fileRelPath) {
        console.warn('No file relative path provided');
        return;
    }
    const fileContentEl = document.querySelector('[data-kui-code-file-content]');
    if (!fileContentEl) {
        console.error('File content element not found');
        return;
    }
    // Handle loading state if click-initiated
    if (treeViewItemEl) $cf732846c258c36a$var$handleFetchLoading(true, treeViewItemEl, fileContentEl);
    try {
        const csrfToken = document.head.querySelector('[name=csrf-token][content]')?.content;
        const response = await fetch(`/make/v1/file_contents/${encodeURIComponent(fileRelPath)}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                ...csrfToken ? {
                    'X-CSRF-Token': csrfToken
                } : {}
            }
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        if (!data || typeof data.name === 'undefined') throw new Error('Invalid response data');
        const fileName = data.name ?? 'unknown_file';
        const fileExt = fileName.split('.').pop()?.toLowerCase() ?? '';
        // Update content and language
        fileContentEl.textContent = data.content ?? '';
        const lang = $cf732846c258c36a$var$getLangFromFile(fileName, fileExt);
        // Remove existing language classes first
        fileContentEl.classList.forEach((cls)=>{
            if (cls.startsWith('language-')) fileContentEl.classList.remove(cls);
        });
        // Add new language class and ensure line-numbers exists
        fileContentEl.classList.add(`language-${lang}`, 'line-numbers');
        // Only initialise Prism for click events and non-plaintext languages
        if (treeViewItemEl && lang !== 'plaintext') await (0, $1Wath.init)(fileContentEl);
        // Update breadcrumb
        const breadcrumbEl = document.querySelector('[data-kui-code-file-path]');
        if (breadcrumbEl) {
            let breadcrumbHTML = '';
            if (data.directory_path && data.directory_path.trim() !== '') {
                const pathParts = data.directory_path.split(',').filter((part)=>part.trim() !== '');
                // Add directory parts (all except the last one)
                for(let i = 0; i < pathParts.length; i++){
                    const part = pathParts[i].trim();
                    breadcrumbHTML += `
                        <span>
                            ${part}
                            <span class="kui-util-hide-visually">/</span>
                        </span>
                        <svg class="kinde-icon kinde-icon-size-small" data-kinde-icon="true" fill="none" aria-hidden="true" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m9 18 6-6-6-6"/>
                        </svg>
                    `;
                }
            }
            // Always add the filename with file icon at the end
            breadcrumbHTML += `
                <span>
                    <svg class="kinde-icon kinde-icon-size-small" data-kinde-icon="true" fill="none" aria-hidden="true" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke="currentColor" stroke-width="1.5" d="M4.5 3.75a1 1 0 0 1 1-1h8.06a1 1 0 0 1 .737.324l4.94 5.39a1 1 0 0 1 .263.675V20.25a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1z"></path>
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M14 2.75v6h5.5"></path>
                        <path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M7.75 12.5h8.5m-8.5 3.75h8.5m-8.5-7.5h2.5"></path>
                    </svg>
                    ${fileName}
                </span>
            `;
            breadcrumbEl.innerHTML = breadcrumbHTML;
        }
    } catch (error) {
        console.error('Error fetching file contents:', error);
        fileContentEl.textContent = 'Error loading file content';
    } finally{
        // Only remove loading state if it was a click event
        if (treeViewItemEl) $cf732846c258c36a$var$handleFetchLoading(false, treeViewItemEl, fileContentEl);
    }
};
const $cf732846c258c36a$export$17807f1eefa3a569 = async (el)=>{
    const fileRelPath = el.dataset.kuiTreeViewFileRelPath;
    await $cf732846c258c36a$var$fetchAndRenderFile(fileRelPath, el);
};
const $cf732846c258c36a$export$81e4b5add1c426 = async (el)=>{
    const fileRelPath = el.dataset.kuiCodeFileRelPath;
    await $cf732846c258c36a$var$fetchAndRenderFile(fileRelPath);
};

});



parcelRegister("9Ju4i", function(module, exports) {

$parcel$export(module.exports, "PAGE_LOADER_DELAY_MS", function () { return $715fa3fb953e59c8$export$1b72fc6512ad82fc; });
const $715fa3fb953e59c8$export$c67b16f016ec1b96 = 400;
const $715fa3fb953e59c8$export$1b72fc6512ad82fc = 800;

});


parcelRegister("bNurD", function(module, exports) {

$parcel$export(module.exports, "toggleDisabled", function () { return $896be30473093370$export$cf89fc75ae1f5593; });

var $laGbt = parcelRequire("laGbt");

var $fHULH = parcelRequire("fHULH");
const $896be30473093370$var$toggler = (el, isDisabled)=>{
    const { toggleDisabledSelector: toggleDisabledSelector } = (0, $fHULH.kuiset)(el);
    const fields = [
        ...document.querySelectorAll(toggleDisabledSelector)
    ];
    fields.forEach((field)=>{
        field.disabled = isDisabled;
    });
};
const $896be30473093370$var$toggleOn = (el)=>$896be30473093370$var$toggler(el, true);
const $896be30473093370$var$toggleOff = (el)=>$896be30473093370$var$toggler(el, false);
const $896be30473093370$var$toggle = (el)=>$896be30473093370$var$toggler(el, !el.checked);
const $896be30473093370$var$inputTypePassword = (el)=>{
    const toggleParams = (0, $fHULH.kuiset)(el);
    const nextState = toggleParams.toggleState === 'On' ? 'Off' : 'On';
    const fields = [
        ...document.querySelectorAll(toggleParams.toggleSelector)
    ];
    fields.forEach((field)=>{
        field.type = toggleParams[`toggleAttribute${nextState}Value`];
    });
    el.setAttribute('aria-label', toggleParams[`toggle${nextState}Text`]);
    el.setAttribute('kui-toggle-state', nextState);
};
const $896be30473093370$export$cf89fc75ae1f5593 = ()=>{
    (0, $laGbt.register)('toggleDisabled', {
        toggle: $896be30473093370$var$toggle,
        toggleOff: $896be30473093370$var$toggleOff,
        toggleOn: $896be30473093370$var$toggleOn,
        inputTypePassword: $896be30473093370$var$inputTypePassword
    });
};

});

parcelRegister("6t4eb", function(module, exports) {

$parcel$export(module.exports, "phoneNumber", function () { return $4b58bb117502f7f6$export$73d620cb2fed0c37; });

var $laGbt = parcelRequire("laGbt");
const $4b58bb117502f7f6$var$selectCountry = (el)=>{
    const selectedOption = el.options[el.selectedIndex];
    const { icon: icon } = selectedOption.dataset;
    const target = document.querySelector(`[data-select-country-target="true"]`);
    target.textContent = icon;
};
const $4b58bb117502f7f6$export$73d620cb2fed0c37 = ()=>{
    (0, $laGbt.register)('phoneNumber', {
        selectCountry: $4b58bb117502f7f6$var$selectCountry
    });
};

});

parcelRegister("35QD8", function(module, exports) {

$parcel$export(module.exports, "printer", function () { return $240aa9f906423aa7$export$d320c7d7423bc862; });

var $laGbt = parcelRequire("laGbt");
function $240aa9f906423aa7$var$print() {
    window.print();
}
const $240aa9f906423aa7$export$d320c7d7423bc862 = ()=>{
    (0, $laGbt.register)('printer', {
        print: $240aa9f906423aa7$var$print
    });
};

});

parcelRegister("kBVeO", function(module, exports) {

$parcel$export(module.exports, "focusInvalidControl", function () { return $f013a997ca4f2a07$export$586190a6ccdbede0; });

var $laGbt = parcelRequire("laGbt");
const $f013a997ca4f2a07$var$init = (el)=>{
    const form = el.closest('form');
    const hook = 'data-is-invalid-field-focussed';
    if (form && !form.getAttribute(hook)) {
        const invalidControls = [
            ...form.querySelectorAll('[aria-invalid="true"]')
        ];
        const firstInvalidControl = invalidControls[0];
        // Set a flag so it only runs once
        form.setAttribute(hook, 'true');
        firstInvalidControl.focus({
            focusVisible: true
        });
    }
};
const $f013a997ca4f2a07$export$586190a6ccdbede0 = ()=>{
    (0, $laGbt.register)('focusInvalidControl', {
        init: $f013a997ca4f2a07$var$init
    });
};

});

parcelRegister("lv12l", function(module, exports) {

$parcel$export(module.exports, "copyToClipboard", function () { return $fa6d4c1bdb814d3c$export$2cdf1b96a9f86d16; });

var $laGbt = parcelRequire("laGbt");
const $fa6d4c1bdb814d3c$var$copy = async (button, value)=>{
    try {
        await navigator.clipboard.writeText(value);
        const parent = button.closest('[data-kui-copy-text]');
        const liveRegion = parent.querySelector('[aria-live]');
        parent.classList.add('is-active');
        if (liveRegion) liveRegion.textContent = 'Copied';
        setTimeout(()=>{
            parent.classList.remove('is-active');
            liveRegion.textContent = null;
            button.focus();
        }, 2000);
    } catch (err) {
        console.error(err);
    }
};
const $fa6d4c1bdb814d3c$var$type = (el)=>{
    const target = document.getElementById('target');
    target.textContent = el.value;
};
const $fa6d4c1bdb814d3c$var$write = async (el)=>{
    const value = el.value;
    await $fa6d4c1bdb814d3c$var$copy(el, value);
};
const $fa6d4c1bdb814d3c$var$code = async (el)=>{
    const container = el.closest('[data-code-block="true"]');
    const codeBlock = container.querySelector('[data-copy-to-clipboard-target="true"]');
    await $fa6d4c1bdb814d3c$var$copy(el, codeBlock.innerText);
};
const $fa6d4c1bdb814d3c$export$2cdf1b96a9f86d16 = ()=>{
    (0, $laGbt.register)('copyToClipboard', {
        write: $fa6d4c1bdb814d3c$var$write,
        type: $fa6d4c1bdb814d3c$var$type,
        code: $fa6d4c1bdb814d3c$var$code
    });
};

});

parcelRegister("hWeRA", function(module, exports) {

$parcel$export(module.exports, "subdomainFromString", function () { return $d0f361f76023a180$export$e45d0408cc2ff9a8; });

var $laGbt = parcelRequire("laGbt");
const $d0f361f76023a180$var$update = (el)=>{
    const { subdomainTargetSelector: subdomainTargetSelector } = el.dataset;
    const target = document.querySelector(subdomainTargetSelector);
    target.value = el.value.replaceAll(' ', '').toLowerCase();
};
const $d0f361f76023a180$export$e45d0408cc2ff9a8 = ()=>{
    (0, $laGbt.register)('subdomainFromString', {
        update: $d0f361f76023a180$var$update
    });
};

});

parcelRegister("cz2rK", function(module, exports) {

$parcel$export(module.exports, "dropdown", function () { return $925aa6c2cd58458b$export$81207e5cc4186890; });

var $fHULH = parcelRequire("fHULH");

var $laGbt = parcelRequire("laGbt");

var $92Eyg = parcelRequire("92Eyg");

var $6E8fP = parcelRequire("6E8fP");

var $cqg6e = parcelRequire("cqg6e");
const $925aa6c2cd58458b$var$closeAllDropdowns = ()=>{
    const openTriggers = (0, $6E8fP.findAll)('[kui-dropdown-trigger="true"][aria-expanded="true"]');
    if (openTriggers) (0, $92Eyg.each)(openTriggers, $925aa6c2cd58458b$var$toggleDropdown);
};
const $925aa6c2cd58458b$var$closeOtherDropdowns = (button)=>{
    /* Temp nasty hack to allow nested dropdowns */ const parentDropdown = button.closest('[kui-dropdown-content="true"]');
    const openTriggers = (0, $6E8fP.findAll)('[kui-dropdown-trigger="true"][aria-expanded="true"]');
    const openDropdowns = (0, $6E8fP.findAll)('.is-active[kui-dropdown-content="true"]');
    if (openTriggers) (0, $92Eyg.each)(openTriggers, (button)=>{
        if (!parentDropdown?.id || button.getAttribute('aria-controls') !== parentDropdown?.id) button.setAttribute('aria-expanded', false);
    });
    if (openDropdowns) (0, $92Eyg.each)(openDropdowns, (d)=>{
        if (!parentDropdown?.id || d.id !== parentDropdown?.id) d.classList.remove('is-active');
    });
};
const $925aa6c2cd58458b$var$handleClickOutside = ()=>{
    $925aa6c2cd58458b$var$closeAllDropdowns();
};
const $925aa6c2cd58458b$var$handleEscape = (e)=>{
    if (e.key === 'Escape') $925aa6c2cd58458b$var$closeAllDropdowns();
};
const $925aa6c2cd58458b$var$onPressEscape = ()=>{
    document.body.addEventListener('keyup', $925aa6c2cd58458b$var$handleEscape);
};
const $925aa6c2cd58458b$var$offPressEscape = ()=>{
    document.body.removeEventListener('keyup', $925aa6c2cd58458b$var$handleEscape);
};
const $925aa6c2cd58458b$var$toggleDropdown = (button)=>{
    const { dropdownControls: dropdownControls } = (0, $fHULH.kuiset)(button);
    const isExpanded = button.getAttribute('aria-expanded') === 'true' || false;
    const clickOutside = isExpanded ? (0, $cqg6e.offClickOutside) : (0, $cqg6e.onClickOutside);
    const pressEscape = isExpanded ? $925aa6c2cd58458b$var$offPressEscape : $925aa6c2cd58458b$var$onPressEscape;
    const dropdown = document.getElementById(dropdownControls);
    const isNewDropdown = dropdown.classList.contains('kui-dropdown-menu');
    const firstFocusableElement = dropdown.querySelector('a[href]:first-child, button[type="submit"]');
    $925aa6c2cd58458b$var$closeOtherDropdowns(button);
    button.setAttribute('aria-expanded', !isExpanded);
    if (!isExpanded) {
        dropdown.classList.add('is-active');
        if (isNewDropdown) firstFocusableElement.focus({
            focusVisible: true
        });
    }
    clickOutside('[kui-dropdown]', $925aa6c2cd58458b$var$handleClickOutside);
    pressEscape();
};
const $925aa6c2cd58458b$export$81207e5cc4186890 = ()=>{
    (0, $laGbt.register)('dropdown', {
        toggle: $925aa6c2cd58458b$var$toggleDropdown
    });
};

});
parcelRegister("cqg6e", function(module, exports) {

$parcel$export(module.exports, "onClickOutside", function () { return $90b466c4ebd94a2a$export$806d9a98fb0e6fd0; });
$parcel$export(module.exports, "offClickOutside", function () { return $90b466c4ebd94a2a$export$b11765aa2bd19bdc; });
const $90b466c4ebd94a2a$export$806d9a98fb0e6fd0 = (selector, func)=>{
    document.body.addEventListener('mouseup', (e)=>{
        if (!e.target.closest(selector)) func();
    });
};
const $90b466c4ebd94a2a$export$b11765aa2bd19bdc = (selector, func)=>{
    document.body.removeEventListener('mouseup', (e)=>{
        if (!e.target.closest(selector)) func();
    });
};

});


parcelRegister("bzSJd", function(module, exports) {

$parcel$export(module.exports, "submitOnChange", function () { return $86dd6a808e15f8e0$export$c4673034fb390a57; });

var $laGbt = parcelRequire("laGbt");
function $86dd6a808e15f8e0$var$fire(el) {
    const form = el.closest('form');
    const button = form.querySelector('button');
    button.click();
}
const $86dd6a808e15f8e0$export$c4673034fb390a57 = ()=>{
    (0, $laGbt.register)('submitOnChange', {
        fire: $86dd6a808e15f8e0$var$fire
    });
};

});

parcelRegister("cMX39", function(module, exports) {

$parcel$export(module.exports, "eventHandler", function () { return $94f7c5c72fc3c2b7$export$312115c8de5dbe92; });

var $laGbt = parcelRequire("laGbt");
const $94f7c5c72fc3c2b7$var$remove = (el)=>{
    const { eventHandlerToRemove: eventHandlerToRemove } = el.dataset;
    el.removeAttribute(eventHandlerToRemove);
};
const $94f7c5c72fc3c2b7$export$312115c8de5dbe92 = ()=>{
    (0, $laGbt.register)('eventHandler', {
        remove: $94f7c5c72fc3c2b7$var$remove
    });
};

});


var $6NpK2 = parcelRequire("6NpK2");

var $6Tjdo = parcelRequire("6Tjdo");

var $bNurD = parcelRequire("bNurD");

var $6t4eb = parcelRequire("6t4eb");

var $35QD8 = parcelRequire("35QD8");

var $4C6DL = parcelRequire("4C6DL");

var $kBVeO = parcelRequire("kBVeO");

var $lv12l = parcelRequire("lv12l");

var $hWeRA = parcelRequire("hWeRA");

var $cz2rK = parcelRequire("cz2rK");

var $bzSJd = parcelRequire("bzSJd");

var $cMX39 = parcelRequire("cMX39");
/* Global */ (0, $6NpK2.default)();
(0, $4C6DL.unsavedChanges)();
(0, $kBVeO.focusInvalidControl)();
/* MFA recovery codes */ (0, $lv12l.copyToClipboard)();
(0, $35QD8.printer)();
/* Input components */ (0, $6t4eb.phoneNumber)();
(0, $bNurD.toggleDisabled)(); /* Password visibility toggle */ 
/* Autocomplete Kinde business */ (0, $hWeRA.subdomainFromString)();
(0, $cMX39.eventHandler)();
/* Preview mode - ideally remove */ (0, $bzSJd.submitOnChange)();
(0, $cz2rK.dropdown)();
// NOTE: Should always come last to bind all other JS
(0, $6Tjdo.bind)();


parcelRequire("8iBev");
})();
//# sourceMappingURL=authflow.js.map
